var _path, _polygon, _polygon2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBba(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-190"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.45,
    y: 34.89,
    width: 19.24,
    height: 76.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.75,
    y: 51.66,
    width: 19.24,
    height: 60.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.47,
    y: 65.38,
    width: 19.24,
    height: 46.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.07,
    y: 84.22,
    width: 19.24,
    height: 27.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,387.92a28,28,0,0,0-12-4.13c-2-.21-4.1-.15-5.68,1a1.16,1.16,0,0,0-.58,1,1.28,1.28,0,0,0,.55.71,17.18,17.18,0,0,0,17.72,1.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,387.58a58.56,58.56,0,0,1-7.75-6.82,19.62,19.62,0,0,1-4.87-9,3.66,3.66,0,0,1,.39-3c6.18,4.83,11,11.08,12.23,18.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.27,387.87a27.86,27.86,0,0,1,.14-10.18,13.75,13.75,0,0,1,5.43-8.4c1.06,2.49.6,5.37-.15,8a38.76,38.76,0,0,1-5.38,11.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,398.73a17.73,17.73,0,0,0-9.63,4.88,18.19,18.19,0,0,0-5.51,9.45c3.61-.22,6.67-2.77,8.89-5.62s3.76-6,6.2-8.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.64,400.47A23.75,23.75,0,0,1,51.39,378c2.09,7.46,1.32,15.88-2.75,22.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.65,410a17.18,17.18,0,0,0-16.42,9.46,1.29,1.29,0,0,0-.11,1.29,1.26,1.26,0,0,0,1.09.32c3.23-.21,6.1-2.16,8.47-4.38s4.43-4.78,7-6.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,409.49a30.57,30.57,0,0,1-.31-17.09c.6-2.2,1.61-4.51,3.65-5.55a.74.74,0,0,1,.56-.09.73.73,0,0,1,.35.4,10.43,10.43,0,0,1,.86,4.91,31,31,0,0,1-.77,5c-.64,3-1,6.29-2.65,8.91A18.3,18.3,0,0,0,57,407.89c-.32.67-.32.9-.61,1.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.59,412.64a22,22,0,0,1,3.86-18.11c.28-.36.65-.75,1.1-.7.7.06.88,1,.84,1.68a32.62,32.62,0,0,1-5.8,17.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,414a26.34,26.34,0,0,0,21.62-4.4,17.47,17.47,0,0,0-11.7-1.43c-3.91.89-7.48,2.64-9.92,5.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,410a25,25,0,0,1,19.62-11.34,12.11,12.11,0,0,1-6.42,7.09,36,36,0,0,1-9.42,2.76c-1.25.24-3,.51-3.78,1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,390.67a56.82,56.82,0,0,0,2.51-11.49,19.17,19.17,0,0,0-2.29-11.37,25,25,0,0,0-.34,23.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.78,384.21c4.44-8.07,13.5-14.51,22.67-15.42-3.54,8.81-13.18,15.61-22.67,15.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,385.79c6.62,1,12.26,5.24,18.45,7.8a8.2,8.2,0,0,0,4.17.8,3.26,3.26,0,0,0,2-5.77,8.94,8.94,0,0,0-3-1.84c-6.74-2.81-14-2.88-21.06-1.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,390.44c1.49.43,2,1.2,3.19,2.21a34.58,34.58,0,0,0,14,7.19c.53.13,1.23.19,1.5-.3s-.06-.93-.37-1.3A19.14,19.14,0,0,0,94,392.5c-3.23-1.2-6-2.65-9.88-2.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,362.39a26.5,26.5,0,0,0,20.3,6.9,1.37,1.37,0,0,0,.93-.33c.51-.55-.11-1.41-.7-1.88-6-4.65-13.2-6.58-20.53-4.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,360.51a28.27,28.27,0,0,1,25.33-4.18,20.12,20.12,0,0,1-12.07,5.3A38.26,38.26,0,0,1,85,360.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.92,347.62c-.59-6-.21-10.66-.62-16.65,0-.47-.13-1.05-.58-1.22-.63-.24-1.14.52-1.35,1.16a19.11,19.11,0,0,0,2.54,16.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,348.28a35.06,35.06,0,0,0,9.87-9.59c2-2.67,3.59-5.87,3.15-9.14a9.46,9.46,0,0,0-7.12,3.54,19.87,19.87,0,0,0-3.63,7.3c-.79,2.62-1.34,5.31-2.27,7.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.19,345.58a79.3,79.3,0,0,0,24.28-14.32c-2.9-1.16-6.22-.47-9.12.71a28.74,28.74,0,0,0-15.29,13.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.22,351.54a49.09,49.09,0,0,0,13.48.06,56.92,56.92,0,0,0,12.59-4.18,1.46,1.46,0,0,0,.86-.65,1,1,0,0,0-.31-1.08,2.7,2.7,0,0,0-1.07-.5,23.38,23.38,0,0,0-13.61.81,63.44,63.44,0,0,0-11.94,5.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62,362.59a23.85,23.85,0,0,1-.22-19.74c1.86,2.83,2.09,6.44,1.75,9.81s-1.37,6.85-1.44,10.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4,356.43a27.53,27.53,0,0,0-20.46,8.71,19.12,19.12,0,0,0,11.2-2.07,57,57,0,0,0,9.6-6.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.18,353.68c-3.73-.3-7.33-.77-10.92.33a13.16,13.16,0,0,0-8.33,7.06,19.67,19.67,0,0,0,10.24-1.93,58.27,58.27,0,0,0,9-5.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.35,353.8c-3.36-2.2-6.82-4.44-10.73-5.35s-8.45-.24-11.18,2.71c3.17,1.86,7,2.08,10.69,2.07s8.17,0,11.64,1.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37,354c-5.75-5.64-7.93-15.78-5.62-23.49A35.82,35.82,0,0,1,51.37,354",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17,338c1.08-2.52,1.84-5.17,2.81-7.73a22.5,22.5,0,0,1,4-7.13,10.58,10.58,0,0,1,7.12-3.68A28.69,28.69,0,0,1,67.31,338",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,341.33c-1.8-2.47-3.87-5.82-6.3-7.66a10.5,10.5,0,0,0-8.57-2.25,20,20,0,0,0,14.87,9.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,338.2A42.6,42.6,0,0,1,62,329a14.37,14.37,0,0,1,1.44-9.33c3.16,6,4.17,12.36,1.56,18.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,319.69c1.78-5.91,7.19-10.26,13-12.26a4.83,4.83,0,0,1,2.28-.34,2,2,0,0,1,1.69,1.4c.21,1-.62,1.91-1.4,2.58a44.47,44.47,0,0,1-15.61,8.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26,314.85c.23-3.81.46-7.67,1.7-11.28s3.63-7,7.11-8.58c.59,3.85-1.11,7.68-3.16,11s-4.51,6.44-5.74,10.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17,317.48C65.69,313.17,65.54,307.7,63,304c-1.81-2.63-4.69-4.41-6.25-7.19a10.94,10.94,0,0,0,.37,8.16,23.7,23.7,0,0,0,4.77,6.83c1.91,2,3.54,3.57,5.32,5.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,444.33c-.12,0-.22-28.74-.23-64.17s.08-64.18.2-64.18.21,28.72.22,64.18S67.31,444.33,67.2,444.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.31,358.25a6.64,6.64,0,0,1-1.08.41l-3,1c-2.5.86-6,2.09-9.69,3.62s-7.19,2.88-9.18,4.6a6.75,6.75,0,0,0-1.84,2.44c-.28.68-.34,1.09-.37,1.08s0-.1,0-.3a4.14,4.14,0,0,1,.21-.83,6.51,6.51,0,0,1,1.8-2.61,16.07,16.07,0,0,1,4-2.47c1.6-.74,3.36-1.52,5.24-2.29,3.75-1.54,7.22-2.73,9.75-3.52,1.27-.39,2.3-.68,3-.88A8.24,8.24,0,0,1,92.31,358.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,338a2,2,0,0,1-.31.32l-.92.87-3.44,3.12-11.46,10.2c-4.47,4-8.33,7.79-11,10.65-1.34,1.43-2.4,2.62-3.12,3.44l-.83,1a2.28,2.28,0,0,1-.31.31s.07-.13.24-.37.43-.57.78-1c.68-.86,1.7-2.08,3-3.54a146.26,146.26,0,0,1,11-10.76c4.48-4,8.57-7.54,11.54-10.11l3.53-3,1-.8A1.65,1.65,0,0,1,100.54,338Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.59,356.6c-.12-.05.81-2.21,1.74-4.94s1.38-5,1.5-5a16.74,16.74,0,0,1-1.1,5.15,35.29,35.29,0,0,1-1.39,3.45A5.61,5.61,0,0,1,79.59,356.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,374a4.54,4.54,0,0,1-.69-.8c-.47-.6-1.06-1.35-1.76-2.26-1.49-1.92-3.54-4.56-5.83-7.46S54.52,358,53,356.1l-1.8-2.24a5.19,5.19,0,0,1-.62-.85,5.47,5.47,0,0,1,.74.75c.46.5,1.11,1.23,1.91,2.15,1.59,1.83,3.74,4.4,6,7.3s4.32,5.58,5.74,7.54c.71,1,1.28,1.79,1.66,2.35A6.2,6.2,0,0,1,67.22,374Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.72,366.93a10.1,10.1,0,0,1-2.31-4.32,12.3,12.3,0,0,1-.52-4.36l.18,0c-.08.33-.14.51-.18.5s0-.19,0-.53h.18a20.17,20.17,0,0,0,.74,4.24A31.38,31.38,0,0,0,61.72,366.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,358a8.25,8.25,0,0,0-1.61-.93,10.75,10.75,0,0,0-4.47-.36,27.56,27.56,0,0,0-4.51.73,12.92,12.92,0,0,1-1.85.44,7,7,0,0,1,1.77-.72,20.15,20.15,0,0,1,4.55-.86,9.64,9.64,0,0,1,4.62.5A3,3,0,0,1,54.61,358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.92,355.82c0,.06-.94-.38-2.46-.9A24.8,24.8,0,0,0,38,354c-1.59.29-2.55.58-2.57.51a2.6,2.6,0,0,1,.65-.27,15.42,15.42,0,0,1,1.86-.53,22.09,22.09,0,0,1,12.6,1,16.06,16.06,0,0,1,1.76.8C52.72,355.66,52.94,355.79,52.92,355.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.17,346.65a50.56,50.56,0,0,1-1.8-6.25,50.05,50.05,0,0,1-1.4-6.35,50.56,50.56,0,0,1,1.8,6.25A52.69,52.69,0,0,1,67.17,346.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,346.65a29.43,29.43,0,0,0-2-3.74,16.73,16.73,0,0,0-2.94-3,2.78,2.78,0,0,1,1.13.59,9,9,0,0,1,2.15,2.2A8.34,8.34,0,0,1,67.28,346.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,429s-.13-.69-.46-1.91a27.2,27.2,0,0,0-1.92-5,68.8,68.8,0,0,0-10.19-14.35c-2.27-2.6-4.48-5-6.35-7.4a50.3,50.3,0,0,1-4.54-6.55,31.65,31.65,0,0,1-2.3-4.86c-.21-.6-.36-1.07-.45-1.39a3.27,3.27,0,0,1-.12-.5s.25.66.72,1.83a37,37,0,0,0,2.4,4.77,54.44,54.44,0,0,0,4.59,6.46c1.88,2.33,4.09,4.76,6.37,7.37A65.29,65.29,0,0,1,65.09,422a24.51,24.51,0,0,1,1.81,5.06,14.21,14.21,0,0,1,.25,1.44A3.8,3.8,0,0,1,67.2,429Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,403.38a11.2,11.2,0,0,1-1.19.67,25.65,25.65,0,0,0-3.09,2,35.79,35.79,0,0,0-4,3.69c-1.42,1.5-2.88,3.25-4.38,5.12-3,3.75-5.78,7.07-7.46,9.71-.85,1.32-1.47,2.43-1.87,3.2a11.34,11.34,0,0,1-.65,1.2s0-.12.11-.34a9.46,9.46,0,0,1,.4-.93,30.22,30.22,0,0,1,1.76-3.28,106.74,106.74,0,0,1,7.39-9.82c1.49-1.88,3-3.62,4.43-5.12a32.45,32.45,0,0,1,4.15-3.67,20.7,20.7,0,0,1,3.18-1.94c.4-.2.72-.32.93-.42A1.57,1.57,0,0,1,89.89,403.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.33,411.7a18.19,18.19,0,0,1-2.51.36,33.39,33.39,0,0,0-6,1.17A18,18,0,0,0,76.52,416c-1.23.95-1.81,1.73-1.87,1.69a1.85,1.85,0,0,1,.37-.58,9.82,9.82,0,0,1,1.31-1.34,16.21,16.21,0,0,1,5.4-3,26.65,26.65,0,0,1,6.06-1.07A12.39,12.39,0,0,1,90.33,411.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.38,416.81c-.13-.07,1-1.8,1.88-4.13s1-4.41,1.17-4.38a4.17,4.17,0,0,1,0,1.35,14.33,14.33,0,0,1-.74,3.17,14.91,14.91,0,0,1-1.45,2.92C75.75,416.44,75.43,416.84,75.38,416.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,381.06a2.19,2.19,0,0,1-.41.21l-1.18.54c-.52.22-1.14.5-1.85.88s-1.54.74-2.4,1.26l-1.37.78c-.48.27-1,.6-1.45.91-1,.61-2,1.37-3.11,2.14a58.54,58.54,0,0,0-6.48,5.7,57.58,57.58,0,0,0-5.47,6.67c-.74,1.11-1.46,2.15-2,3.18-.3.51-.61,1-.87,1.47s-.49.95-.73,1.4c-.49.88-.83,1.72-1.18,2.44s-.61,1.36-.81,1.89-.36.88-.5,1.19-.18.42-.2.41a2.09,2.09,0,0,1,.13-.43l.42-1.23a19.94,19.94,0,0,1,.75-1.92c.32-.73.66-1.59,1.13-2.48l.71-1.42c.25-.49.56-1,.85-1.5.57-1,1.28-2.1,2-3.22a56.4,56.4,0,0,1,5.5-6.74,54.88,54.88,0,0,1,6.55-5.72c1.09-.77,2.12-1.52,3.15-2.12.5-.31,1-.63,1.46-.9l1.4-.76c.87-.5,1.72-.87,2.44-1.21a19.75,19.75,0,0,1,1.89-.82l1.21-.47A1.88,1.88,0,0,1,97.24,381.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,393.09a2.88,2.88,0,0,1,1-1.47,6.3,6.3,0,0,1,4-1.53,11.09,11.09,0,0,1,4.19.82,6,6,0,0,1,1.58.77,9.83,9.83,0,0,1-1.68-.49,12.8,12.8,0,0,0-4.07-.68,6.5,6.5,0,0,0-3.8,1.33A10.78,10.78,0,0,0,79.28,393.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59,395.86a14.69,14.69,0,0,0,1.13-3.68,14.94,14.94,0,0,0-.25-3.83,2.54,2.54,0,0,1,.47,1.07,7.69,7.69,0,0,1-.65,5.51C76.94,395.56,76.63,395.89,76.59,395.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35,433.13c.62,11,3.93,22.15,9,33.44H78.5c4.86-11.18,7.94-22.33,8.48-33.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,450.9c0,.11-7.29.2-16.28.2s-16.28-.09-16.28-.2,7.29-.21,16.28-.21S83.4,450.78,83.4,450.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,454.88c0,.11-6.83.2-15.26.2s-15.25-.09-15.25-.2,6.83-.21,15.25-.21S82.9,454.76,82.9,454.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.72,440.34a61.91,61.91,0,0,1,0,10.19,65,65,0,0,1,0-10.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,440.34a66.48,66.48,0,0,1,0,10.56,69.8,69.8,0,0,1,0-10.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,440.25a72.6,72.6,0,0,1,0,10.77,69.15,69.15,0,0,1,0-10.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.28,440.34c0,.11-8.55.21-19.09.21s-19.09-.1-19.09-.21,8.55-.21,19.09-.21S86.28,440.22,86.28,440.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.77,
    y: 35.69,
    width: 183.5,
    height: 113.57,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,117.8c-12.73-4.82-27.36,8.52-39.84,3.08-7.25-3.17-10.54-11.38-14.1-18.45s-9.68-14.54-17.56-13.72-14.37,10-22,7.81c-4.84-1.4-7.25-6.76-8.46-11.65s-2.06-10.28-5.75-13.71-11.37-2.51-12,2.49v60.21h143.5S210.37,119.47,206,117.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,133.86c0,.13-34.78.23-77.67.23s-77.69-.1-77.69-.23,34.78-.23,77.69-.23S233.6,133.73,233.6,133.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,107.56c0,.13-34.78.24-77.67.24s-77.69-.11-77.69-.24,34.78-.23,77.69-.23S233.6,107.43,233.6,107.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,81.26c0,.13-34.78.24-77.67.24s-77.69-.11-77.69-.24S113,81,155.93,81,233.6,81.14,233.6,81.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,56.27c0,.13-34.78.24-77.67.24s-77.69-.11-77.69-.24S113,56,155.93,56,233.6,56.14,233.6,56.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.51,466.57c0,.14-153.26.26-342.28.26s-342.31-.12-342.31-.26,153.23-.26,342.31-.26S716.51,466.42,716.51,466.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.27,78.51H177.17a13.42,13.42,0,0,0-13.42,13.42V395.72a13.42,13.42,0,0,0,13.42,13.43H342.24s10.51,40.62-22.05,57.42H474.55s-36.76-20.75-27.31-57.42h160a13.43,13.43,0,0,0,13.43-13.43V91.93A13.42,13.42,0,0,0,607.27,78.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,377.2c5.85,8.36-3.31,17.52-11.67,11.67a3.08,3.08,0,0,1-.72-.72c-5.84-8.36,3.31-17.51,11.67-11.67A3.08,3.08,0,0,1,398,377.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 84.09,
    width: 443.67,
    height: 269.48,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.88,
    y: 291.59,
    width: 13.03,
    height: 17.94,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.88,
    y: 291.59,
    width: 13.03,
    height: 17.94,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 522.37,
    y: 281.03,
    width: 13.03,
    height: 28.5,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.37,
    y: 281.03,
    width: 13.03,
    height: 28.5,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 492.69,
    y: 272.45,
    width: 13.03,
    height: 36.61,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.69,
    y: 272.45,
    width: 13.03,
    height: 36.61,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.46,
    y: 284.32,
    width: 13.03,
    height: 24.74,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.46,
    y: 284.32,
    width: 13.03,
    height: 24.74,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 245.74,
    y: 294.44,
    width: 13.03,
    height: 14.62,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.74,
    y: 294.44,
    width: 13.03,
    height: 14.62,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 272.02,
    y: 275.97,
    width: 13.03,
    height: 33.55,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.02,
    y: 275.97,
    width: 13.03,
    height: 33.55,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.53,
    y: 291.59,
    width: 13.03,
    height: 17.47,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.53,
    y: 291.59,
    width: 13.03,
    height: 17.47,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 326.58,
    y: 275.97,
    width: 13.03,
    height: 33.08,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.37,
    y: 233.67,
    width: 13.03,
    height: 75.39,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.29,
    y: 202.73,
    width: 13.03,
    height: 106.32,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.1,
    y: 246.35,
    width: 13.03,
    height: 62.7,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.37,
    y: 233.67,
    width: 13.03,
    height: 75.39,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.1,
    y: 246.35,
    width: 13.03,
    height: 62.7,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 463.6,
    y: 236.02,
    width: 13.03,
    height: 73.03,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.85,
    y: 213.81,
    width: 13.03,
    height: 95.25,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.63,189.82h-2v-1h5.19v1h-2V195h-1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.68,192.65a2.49,2.49,0,1,1,2.49,2.39A2.35,2.35,0,0,1,211.68,192.65Zm3.88,0a1.39,1.39,0,1,0-1.39,1.46A1.36,1.36,0,0,0,215.56,192.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.28,188.49V195h-1.05v-.6a1.93,1.93,0,0,1-1.54.66,2.39,2.39,0,0,1,0-4.78,1.91,1.91,0,0,1,1.5.63v-2.4Zm-1.07,4.16a1.39,1.39,0,1,0-1.39,1.46A1.37,1.37,0,0,0,221.21,192.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,192.24V195h-1v-.57a1.65,1.65,0,0,1-1.47.63c-1.07,0-1.74-.58-1.74-1.4s.52-1.39,1.94-1.39h1.2v-.07c0-.63-.38-1-1.16-1a2.29,2.29,0,0,0-1.41.46l-.43-.79a3.24,3.24,0,0,1,2-.58C226.85,190.26,227.63,190.9,227.63,192.24Zm-1.1,1.28V193h-1.12c-.75,0-.95.28-.95.62s.34.65.89.65A1.19,1.19,0,0,0,226.53,193.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.31,190.31l-2.18,5.05a1.81,1.81,0,0,1-1.8,1.38,1.91,1.91,0,0,1-1.25-.43l.43-.8a1.2,1.2,0,0,0,.81.32c.38,0,.61-.18.82-.65l.08-.18-2-4.69h1.14l1.47,3.46,1.47-3.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,330.14v3.12h-.32v-2.84h-.74v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.51,333v.29h-2.19V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.25-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.11-.45c.63,0,1,.32,1,.84a1.28,1.28,0,0,1-.51,1l-1.06,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,332.36c0,.52-.38.92-1.13.92a1.59,1.59,0,0,1-1.12-.4l.15-.25a1.36,1.36,0,0,0,1,.36c.52,0,.8-.24.8-.63s-.26-.62-.84-.62h-.22v-.24l.86-1.08h-1.59v-.28h2v.22l-.88,1.11C240.17,331.51,240.5,331.86,240.5,332.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,332.44h-.57v.82h-.29v-.82h-1.6v-.24l1.5-2.06h.33l-1.45,2h1.23v-.72h.28v.72h.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.64,332.34c0,.53-.37.94-1.13.94a1.61,1.61,0,0,1-1.12-.4l.16-.25a1.35,1.35,0,0,0,1,.36c.53,0,.81-.26.81-.64s-.25-.65-1-.65h-.67l.16-1.56h1.71v.28h-1.43l-.1,1h.4C272.29,331.42,272.64,331.78,272.64,332.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,332.32a1,1,0,0,1-1.06,1c-.83,0-1.28-.57-1.28-1.56s.58-1.61,1.42-1.61a1.4,1.4,0,0,1,.74.17l-.12.26a1.09,1.09,0,0,0-.61-.15c-.67,0-1.11.43-1.11,1.28a2.5,2.5,0,0,0,0,.25,1,1,0,0,1,.95-.53A.94.94,0,0,1,288.82,332.32Zm-.31,0c0-.41-.31-.67-.79-.67a.69.69,0,1,0,0,1.35A.69.69,0,0,0,288.51,332.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,330.14v.22l-1.3,2.9h-.35l1.28-2.84h-1.6V331h-.32v-.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,207.81v3.12h-.32V208.1h-.74v-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,209.37c0-1,.53-1.58,1.25-1.58s1.24.59,1.24,1.58-.52,1.59-1.24,1.59S208.4,210.37,208.4,209.37Zm2.17,0c0-.83-.38-1.29-.92-1.29s-.92.46-.92,1.29.37,1.3.92,1.3S210.57,210.21,210.57,209.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,210.71a.24.24,0,0,1,.24-.24.24.24,0,0,1,.24.24.25.25,0,0,1-.24.25A.25.25,0,0,1,211.31,210.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2,209.37c0-1,.52-1.58,1.24-1.58s1.25.59,1.25,1.58-.52,1.59-1.25,1.59S212.2,210.37,212.2,209.37Zm2.16,0c0-.83-.37-1.29-.92-1.29s-.91.46-.91,1.29.37,1.3.91,1.3S214.36,210.21,214.36,209.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,209.37c0-1,.52-1.58,1.24-1.58s1.25.59,1.25,1.58-.53,1.59-1.25,1.59S215.15,210.37,215.15,209.37Zm2.16,0c0-.83-.37-1.29-.92-1.29s-.91.46-.91,1.29.37,1.3.91,1.3S217.31,210.21,217.31,209.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,209.37c0-1,.52-1.58,1.24-1.58s1.25.59,1.25,1.58-.53,1.59-1.25,1.59S218.1,210.37,218.1,209.37Zm2.16,0c0-.83-.37-1.29-.92-1.29s-.92.46-.92,1.29.38,1.3.92,1.3S220.26,210.21,220.26,209.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.91,332.39c0,.55-.47.89-1.22.89s-1.2-.34-1.2-.89a.79.79,0,0,1,.6-.77.71.71,0,0,1-.49-.69c0-.5.43-.82,1.09-.82s1.11.32,1.11.82a.7.7,0,0,1-.5.69A.79.79,0,0,1,320.91,332.39Zm-.33,0c0-.38-.33-.62-.89-.62s-.87.24-.87.62.32.63.87.63S320.58,332.77,320.58,332.38Zm-.89-.88c.49,0,.78-.21.78-.55s-.31-.57-.78-.57-.77.22-.77.56S319.21,331.5,319.69,331.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.87,331.67c0,1.06-.58,1.61-1.42,1.61a1.4,1.4,0,0,1-.74-.17l.12-.26a1.11,1.11,0,0,0,.61.15c.67,0,1.11-.43,1.11-1.28a2.5,2.5,0,0,0,0-.25,1,1,0,0,1-.95.53.94.94,0,0,1-1.05-.93,1,1,0,0,1,1.06-1C336.42,330.11,336.87,330.68,336.87,331.67Zm-.44-.62a.73.73,0,0,0-.82-.67.69.69,0,0,0-.77.68c0,.41.31.67.79.67A.72.72,0,0,0,336.43,331.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,330.14v3.12h-.32v-2.84h-.74v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.18,331.7c0-1,.53-1.59,1.25-1.59s1.24.59,1.24,1.59-.52,1.58-1.24,1.58S352.18,332.69,352.18,331.7Zm2.16,0c0-.84-.37-1.3-.91-1.3s-.92.46-.92,1.3.37,1.29.92,1.29S354.34,332.53,354.34,331.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,330.14v3.12h-.32v-2.84H366v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.63,330.14v3.12h-.32v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,330.14v3.12h-.32v-2.84H382v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,333v.29h-2.19V333l1.3-1.27c.35-.35.41-.56.41-.77,0-.36-.25-.59-.73-.59a1.06,1.06,0,0,0-.85.35l-.22-.19a1.37,1.37,0,0,1,1.1-.45c.63,0,1,.32,1,.84a1.28,1.28,0,0,1-.51,1l-1.06,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94,330.14v3.12h-.29v-2.84H398v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,332.36a.91.91,0,0,1-1,.92,1.38,1.38,0,0,1-1-.4l.14-.25a1.21,1.21,0,0,0,.88.36c.47,0,.73-.24.73-.63s-.23-.62-.76-.62h-.21v-.24l.79-1.08h-1.45v-.28h1.83v.22l-.81,1.11A.85.85,0,0,1,401.5,332.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.17,330.14v3.12h-.32v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.57,332.44h-.63v.82h-.32v-.82h-1.76v-.24l1.66-2.06h.35l-1.59,2h1.35v-.72h.31v.72h.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.12,330.14v3.12h-.32v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,332.34c0,.53-.37.94-1.13.94a1.59,1.59,0,0,1-1.12-.4l.16-.25a1.35,1.35,0,0,0,1,.36c.53,0,.81-.26.81-.64s-.25-.65-1-.65H432l.16-1.56h1.71v.28h-1.43l-.1,1h.4C433.63,331.42,434,331.78,434,332.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.22,330.14v3.12h-.32v-2.84h-.74v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.3,332.32a1,1,0,0,1-1.06,1c-.83,0-1.28-.57-1.28-1.56s.58-1.61,1.43-1.61a1.45,1.45,0,0,1,.74.17l-.13.26a1.09,1.09,0,0,0-.61-.15c-.67,0-1.11.43-1.11,1.28a2.5,2.5,0,0,0,0,.25,1,1,0,0,1,.95-.53A.94.94,0,0,1,450.3,332.32Zm-.31,0c0-.41-.31-.67-.79-.67a.72.72,0,0,0-.8.68c0,.34.29.67.83.67A.68.68,0,0,0,450,332.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.15,330.14v3.12h-.32v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.1,330.14v.22l-1.31,2.9h-.35l1.29-2.84h-1.61V331h-.31v-.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.26,330.14v3.12h-.32v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.41,332.39c0,.55-.47.89-1.22.89s-1.2-.34-1.2-.89a.77.77,0,0,1,.6-.77.71.71,0,0,1-.49-.69c0-.5.43-.82,1.09-.82s1.1.32,1.1.82a.7.7,0,0,1-.49.69A.79.79,0,0,1,482.41,332.39Zm-.33,0c0-.38-.33-.62-.89-.62s-.87.24-.87.62.32.63.87.63S482.08,332.77,482.08,332.38Zm-.89-.88c.49,0,.78-.21.78-.55s-.31-.57-.78-.57-.77.22-.77.56S480.71,331.5,481.19,331.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.3,330.14v3.12H494v-2.84h-.73v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.3,331.67c0,1.06-.58,1.61-1.43,1.61a1.45,1.45,0,0,1-.74-.17l.13-.26a1.09,1.09,0,0,0,.61.15c.67,0,1.1-.43,1.1-1.28a2.26,2.26,0,0,0,0-.25,1,1,0,0,1-.95.53,1,1,0,0,1-1.06-.93,1,1,0,0,1,1.07-1C496.85,330.11,497.3,330.68,497.3,331.67Zm-.44-.62c0-.34-.29-.67-.83-.67a.68.68,0,0,0-.76.68c0,.41.3.67.79.67A.72.72,0,0,0,496.86,331.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.61,333v.29h-2.19V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.26-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.11-.45c.63,0,1,.32,1,.84a1.31,1.31,0,0,1-.51,1l-1.06,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,331.7c0-1,.53-1.59,1.25-1.59s1.24.59,1.24,1.59-.52,1.58-1.24,1.58S511,332.69,511,331.7Zm2.16,0c0-.84-.37-1.3-.91-1.3s-.92.46-.92,1.3.37,1.29.92,1.29S513.15,332.53,513.15,331.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.65,333v.29h-2.19V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.26-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.11-.45c.63,0,1,.32,1,.84a1.31,1.31,0,0,1-.51,1l-1.06,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.92,330.14v3.12h-.32v-2.84h-.74v-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.69,333v.29H538.5V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.26-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.11-.45c.63,0,1,.32,1,.84a1.31,1.31,0,0,1-.51,1L539,333Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.22,333v.29H541V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.26-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.11-.45c.63,0,1,.32,1,.84a1.31,1.31,0,0,1-.51,1l-1.06,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.73,333v.29h-2.19V333l1.3-1.27c.35-.35.42-.56.42-.77,0-.36-.26-.59-.73-.59a1,1,0,0,0-.85.35l-.23-.19a1.39,1.39,0,0,1,1.1-.45c.64,0,1,.32,1,.84a1.3,1.3,0,0,1-.52,1L554,333Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.19,332.36c0,.52-.37.92-1.13.92a1.59,1.59,0,0,1-1.12-.4l.16-.25a1.35,1.35,0,0,0,1,.36c.52,0,.8-.24.8-.63s-.26-.62-.84-.62h-.22v-.24l.86-1.08h-1.59v-.28h2v.22l-.88,1.11C557.86,331.51,558.19,331.86,558.19,332.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.22,325.15c0,.14-80.07.26-178.82.26s-178.84-.12-178.84-.26,80.06-.26,178.84-.26S564.22,325,564.22,325.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.85,
    y: 213.81,
    width: 13.03,
    height: 95.25,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.58,
    y: 275.97,
    width: 13.03,
    height: 33.08,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,210.05a17.44,17.44,0,0,1-6,0,17.44,17.44,0,0,1,6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,210.05a35,35,0,0,1-6,.26,35.07,35.07,0,0,1-6-.26,35.07,35.07,0,0,1,6-.26A35,35,0,0,1,256.29,210.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18,210.05a34.9,34.9,0,0,1-6,.26,34.9,34.9,0,0,1-6-.26,34.9,34.9,0,0,1,6-.26A34.9,34.9,0,0,1,280.18,210.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,210.05a68.79,68.79,0,0,1-12,0,68.79,68.79,0,0,1,12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.88,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.78,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.57,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,210.05a68.67,68.67,0,0,1-11.94,0,68.67,68.67,0,0,1,11.94,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.36,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.26,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.16,210.05a68.79,68.79,0,0,1-11.95,0,68.79,68.79,0,0,1,11.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.07,210.05a68.9,68.9,0,0,1-12,0,68.9,68.9,0,0,1,12,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,210.05a17.44,17.44,0,0,1-6,0,17.44,17.44,0,0,1,6,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,296.09a81.5,81.5,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,79.64,79.64,0,0,1,6.3-6.67A80.68,80.68,0,0,1,230.48,296.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,296.31a81.5,81.5,0,0,1-6.3,6.67,78.57,78.57,0,0,1-6.68,6.3,82.59,82.59,0,0,1,6.31-6.67A81.5,81.5,0,0,1,258.68,296.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,296.08a80.68,80.68,0,0,1-6.31,6.67,78.85,78.85,0,0,1-6.67,6.31,79.79,79.79,0,0,1,6.31-6.68A81.5,81.5,0,0,1,312.53,296.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,284.57a80.68,80.68,0,0,1-6.31,6.67,79.64,79.64,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A79.64,79.64,0,0,1,230.31,284.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,296.28a81.5,81.5,0,0,1-6.3,6.67,79.43,79.43,0,0,1-6.67,6.3,83.45,83.45,0,0,1,6.3-6.67A81.5,81.5,0,0,1,285.24,296.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,284.76a80.68,80.68,0,0,1-6.31,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A80.59,80.59,0,0,1,285.07,284.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,276a76.16,76.16,0,0,1-8.92,8.92A78.27,78.27,0,0,1,281,276Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.38,296.08a81.5,81.5,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,80.59,80.59,0,0,1,6.3-6.68A81.5,81.5,0,0,1,394.38,296.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,284.56a79.43,79.43,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A83.45,83.45,0,0,1,394.2,284.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,271.72a79.43,79.43,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,160.87,160.87,0,0,1,13-13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.38,259.3a81.5,81.5,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A79.43,79.43,0,0,1,394.38,259.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,247.77a79.43,79.43,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,79.64,79.64,0,0,1,6.3-6.67A82.59,82.59,0,0,1,394.2,247.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,234.93a79.43,79.43,0,0,1-6.3,6.67,79.43,79.43,0,0,1-6.67,6.3,83.45,83.45,0,0,1,6.3-6.67A83.45,83.45,0,0,1,394.2,234.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,296.08a80.68,80.68,0,0,1-6.31,6.67,80.68,80.68,0,0,1-6.67,6.31,156.89,156.89,0,0,1,13-13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,284.56a81.5,81.5,0,0,1-6.3,6.67,83.45,83.45,0,0,1-6.67,6.3,79.43,79.43,0,0,1,6.3-6.67A81.5,81.5,0,0,1,421.72,284.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,271.72a81.5,81.5,0,0,1-6.3,6.67,83.45,83.45,0,0,1-6.67,6.3,160.87,160.87,0,0,1,13-13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,259.3a80.68,80.68,0,0,1-6.31,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A78.57,78.57,0,0,1,421.9,259.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,247.77a81.5,81.5,0,0,1-6.3,6.67,82.59,82.59,0,0,1-6.67,6.31,77.67,77.67,0,0,1,6.3-6.67A80.68,80.68,0,0,1,421.72,247.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.52,296.08a81.5,81.5,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,80.59,80.59,0,0,1,6.3-6.68A81.5,81.5,0,0,1,476.52,296.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.35,284.56a80.68,80.68,0,0,1-6.31,6.67,81.5,81.5,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A79.64,79.64,0,0,1,476.35,284.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.35,271.72a80.68,80.68,0,0,1-6.31,6.67,81.5,81.5,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A77.67,77.67,0,0,1,476.35,271.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.52,259.3a81.5,81.5,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A79.43,79.43,0,0,1,476.52,259.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.35,247.77a80.68,80.68,0,0,1-6.31,6.67,80.68,80.68,0,0,1-6.67,6.31,78.85,78.85,0,0,1,6.31-6.67A78.85,78.85,0,0,1,476.35,247.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.35,236.78a80.68,80.68,0,0,1-6.31,6.67,81.5,81.5,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A79.64,79.64,0,0,1,476.35,236.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.32,296.08a81.5,81.5,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,80.59,80.59,0,0,1,6.3-6.68A81.5,81.5,0,0,1,366.32,296.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,284.56a80.68,80.68,0,0,1-6.31,6.67,79.64,79.64,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A79.64,79.64,0,0,1,366.15,284.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,271.72a80.68,80.68,0,0,1-6.31,6.67,79.64,79.64,0,0,1-6.67,6.3,80.68,80.68,0,0,1,6.31-6.67A77.67,77.67,0,0,1,366.15,271.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,296.08a81.5,81.5,0,0,1-6.3,6.67,79.79,79.79,0,0,1-6.68,6.31,79.79,79.79,0,0,1,6.31-6.68A81.5,81.5,0,0,1,339.92,296.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,284.56a81.5,81.5,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,160.87,160.87,0,0,1,13-13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,275.86a38.89,38.89,0,0,1-4.23,4.6,37.86,37.86,0,0,1-4.6,4.23,74.63,74.63,0,0,1,8.83-8.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.32,259.3A81.5,81.5,0,0,1,360,266a81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A79.43,79.43,0,0,1,366.32,259.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.32,236.2a81.5,81.5,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,80.59,80.59,0,0,1,6.3-6.68A81.5,81.5,0,0,1,366.32,236.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,247.77a80.68,80.68,0,0,1-6.31,6.67,78.85,78.85,0,0,1-6.67,6.31,78.85,78.85,0,0,1,6.31-6.67A78.85,78.85,0,0,1,366.15,247.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,296.08a79.43,79.43,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,80.59,80.59,0,0,1,6.3-6.68A83.45,83.45,0,0,1,450,296.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,284.56a81.5,81.5,0,0,1-6.3,6.67,83.45,83.45,0,0,1-6.67,6.3,77.47,77.47,0,0,1,6.3-6.67A81.5,81.5,0,0,1,449.86,284.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,271.72a81.5,81.5,0,0,1-6.3,6.67,83.45,83.45,0,0,1-6.67,6.3,77.47,77.47,0,0,1,6.3-6.67A79.43,79.43,0,0,1,449.86,271.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,259.3a79.43,79.43,0,0,1-6.3,6.67,81.5,81.5,0,0,1-6.67,6.3,81.5,81.5,0,0,1,6.3-6.67A81.29,81.29,0,0,1,450,259.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,247.77a81.5,81.5,0,0,1-6.3,6.67,82.59,82.59,0,0,1-6.67,6.31,75.79,75.79,0,0,1,6.3-6.67A80.68,80.68,0,0,1,449.86,247.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,234.93a81.5,81.5,0,0,1-6.3,6.67,81.29,81.29,0,0,1-6.67,6.3,79.23,79.23,0,0,1,6.3-6.67A81.5,81.5,0,0,1,449.86,234.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,223.26a81.5,81.5,0,0,1-6.3,6.67,83.45,83.45,0,0,1-6.67,6.3,77.47,77.47,0,0,1,6.3-6.67A81.5,81.5,0,0,1,449.86,223.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.64,213.81a56,56,0,0,1-5.19,5.56,56,56,0,0,1-5.56,5.19,54.58,54.58,0,0,1,5.19-5.56A54.58,54.58,0,0,1,447.64,213.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.38,221.88a79.64,79.64,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,81.5,81.5,0,0,1,6.3-6.67A80.68,80.68,0,0,1,394.38,221.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.2,210.36a79.43,79.43,0,0,1-6.3,6.67,79.43,79.43,0,0,1-6.67,6.3,83.45,83.45,0,0,1,6.3-6.67A83.45,83.45,0,0,1,394.2,210.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389,202.73a28.69,28.69,0,0,1-3.7,4.07,29.23,29.23,0,0,1-4.06,3.69,29,29,0,0,1,3.7-4.06A29.74,29.74,0,0,1,389,202.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M505.78,296.55a78.85,78.85,0,0,1-6.31,6.67,78.85,78.85,0,0,1-6.67,6.31,165.59,165.59,0,0,1,13-13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.6,285a81.5,81.5,0,0,1-6.3,6.67,79.43,79.43,0,0,1-6.67,6.3,83.45,83.45,0,0,1,6.3-6.67A81.5,81.5,0,0,1,505.6,285Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.53,272.26a81.74,81.74,0,0,1-6.27,6.63,79.65,79.65,0,0,1-6.63,6.27,159.14,159.14,0,0,1,12.9-12.9Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.42,296.55a77.67,77.67,0,0,1-6.3,6.67,80.68,80.68,0,0,1-6.67,6.31,81.5,81.5,0,0,1,6.3-6.67A82.59,82.59,0,0,1,535.42,296.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.25,285a81.5,81.5,0,0,1-6.3,6.67,81.29,81.29,0,0,1-6.67,6.3,160.87,160.87,0,0,1,13-13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.39,281.05c.05.05-.14.33-.48.74-.17.2-.38.44-.62.7s-.25.27-.38.39l-.2.21-.1.11-.06.05,0,0h0l-.37-.36h0l.37.37h0l0,0-.06.05-.1.11-.21.2-.4.38-.7.62c-.41.34-.68.52-.73.47s.13-.33.47-.73c.17-.21.38-.45.62-.7l.38-.4.2-.21.1-.11.06-.05,0,0h0l.37.37h0c-.73-.73-.2-.2-.37-.36h0l0,0,0-.05.1-.1.21-.21.4-.37.7-.62C526.06,281.19,526.33,281,526.39,281.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.88,296.55a79.64,79.64,0,0,1-6.3,6.67,82.59,82.59,0,0,1-6.67,6.31,81.5,81.5,0,0,1,6.3-6.67A80.68,80.68,0,0,1,562.88,296.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556,291.74a19.39,19.39,0,0,1-3,3.31,18.72,18.72,0,0,1-3.32,2.95,19.39,19.39,0,0,1,2.95-3.31A18.24,18.24,0,0,1,556,291.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.82,108.68c0,.15-99.32.26-221.82.26s-221.85-.11-221.85-.26,99.31-.26,221.85-.26S614.82,108.54,614.82,108.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.11,
    y: 138.93,
    width: 93.07,
    height: 31.13,
    rx: 4.64,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,160.76l-2.61-4.42-1,1.2a1,1,0,0,1-1.77-.58l-.63-8.1a1,1,0,0,1,1.53-.94l6.76,4.15a1,1,0,0,1,.48,1,1,1,0,0,1-.71.84l-1.43.44,3.1,4.18Zm-2.45-6.12,2.79,4.74,1.87-1.14L255,153.79l2.79-.85L251,148.77l-.52,0,.5,0,.64,8.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.83,167.79c-.14,0-.26-6.1-.26-13.62s.12-13.62.26-13.62.26,6.1.26,13.62S271,167.79,270.83,167.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276,148.29a1.73,1.73,0,0,1,1.81-1.75,1.66,1.66,0,0,1,1.26.5l-.23.23a1.37,1.37,0,0,0-1-.4,1.43,1.43,0,1,0,0,2.85,1.34,1.34,0,0,0,1-.41l.23.23a1.64,1.64,0,0,1-1.26.51A1.73,1.73,0,0,1,276,148.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,146.36h.35V150h-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,146.61a.26.26,0,0,1,.26-.25.25.25,0,0,1,.25.24.26.26,0,1,1-.51,0Zm.08.82h.35V150h-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,148.72a1.27,1.27,0,0,1,1.33-1.31,1.14,1.14,0,0,1,1,.51l-.26.18a.9.9,0,0,0-.76-.39,1,1,0,0,0,0,2,.87.87,0,0,0,.76-.38l.26.18a1.14,1.14,0,0,1-1,.51A1.27,1.27,0,0,1,282.18,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.14,148.72l-.62.56V150h-.35v-3.66h.35v2.48l1.55-1.41h.44l-1.11,1.06,1.21,1.53h-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.7,149.72l.16-.27a1.6,1.6,0,0,0,.92.29c.49,0,.7-.17.7-.42,0-.68-1.68-.15-1.68-1.17,0-.43.36-.74,1-.74a1.74,1.74,0,0,1,.92.24l-.16.28a1.28,1.28,0,0,0-.76-.22c-.47,0-.67.18-.67.43,0,.7,1.68.17,1.68,1.17,0,.44-.4.73-1.07.73A1.69,1.69,0,0,1,287.7,149.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83,154.8v7.55h-1.4V156h-1.6V154.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S280.33,161.05,280.33,158.57Zm4.9,0c0-1.82-.71-2.66-1.75-2.66s-1.74.84-1.74,2.66.72,2.67,1.74,2.67S285.23,160.4,285.23,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.41,161.53a.89.89,0,1,1,.89.89A.87.87,0,0,1,287.41,161.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.58,160c0,1.33-1,2.43-3,2.43a4.73,4.73,0,0,1-2.84-.88l.6-1.09a3.54,3.54,0,0,0,2.22.75c1,0,1.6-.44,1.6-1.16s-.47-1.17-2-1.17h-1.83l.39-4.11h4.44V156h-3.25l-.16,1.75h.72C294.68,157.72,295.58,158.69,295.58,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.35,3.89-3.16,3.89S296.38,161.05,296.38,158.57Zm4.9,0c0-1.82-.71-2.66-1.75-2.66s-1.73.84-1.73,2.66.71,2.67,1.73,2.67S301.28,160.4,301.28,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S303.64,161.05,303.64,158.57Zm4.9,0c0-1.82-.72-2.66-1.75-2.66s-1.74.84-1.74,2.66.71,2.67,1.74,2.67S308.54,160.4,308.54,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.12,
    y: 138.93,
    width: 93.07,
    height: 31.13,
    rx: 2.78,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.12,
    y: 138.93,
    width: 93.07,
    height: 31.13,
    rx: 3.41,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389,147.75c0,.74-.53,1.18-1.41,1.18h-.93V150h-.36v-3.45h1.29C388.49,146.57,389,147,389,147.75Zm-.36,0c0-.55-.37-.86-1.06-.86h-.92v1.72h.92C388.29,148.61,388.66,148.29,388.66,147.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,148.83h-2.17a1,1,0,0,0,1,.9,1,1,0,0,0,.8-.34l.19.23a1.26,1.26,0,0,1-1,.42,1.28,1.28,0,0,1-1.36-1.32,1.27,1.27,0,1,1,2.53,0S392,148.79,392,148.83Zm-2.17-.26h1.84a.89.89,0,0,0-.92-.86A.91.91,0,0,0,389.81,148.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,147.41v.34h-.08a.84.84,0,0,0-.88,1V150h-.35v-2.59H393v.5A1,1,0,0,1,394,147.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,147.12v.31h.8v.29h-.79V150h-.35v-2.3h-.46v-.29h.46v-.32a.72.72,0,0,1,.79-.77.8.8,0,0,1,.51.16l-.12.26a.58.58,0,0,0-.38-.13C395.24,146.63,395.08,146.8,395.08,147.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,148.72a1.32,1.32,0,1,1,1.32,1.32A1.27,1.27,0,0,1,396.05,148.72Zm2.28,0a1,1,0,1,0-1,1A.95.95,0,0,0,398.33,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.71,147.41v.34h-.08a.84.84,0,0,0-.88,1V150h-.35v-2.59h.34v.5A1,1,0,0,1,400.71,147.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,148.52V150h-.35v-1.47c0-.55-.28-.83-.74-.83a.83.83,0,0,0-.87.94V150h-.35v-1.47c0-.55-.28-.83-.75-.83a.84.84,0,0,0-.87.94V150h-.35v-2.59h.34v.47a1,1,0,0,1,.95-.49.93.93,0,0,1,.92.54,1.14,1.14,0,0,1,1-.54A1,1,0,0,1,405.62,148.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.53,148.41V150h-.33v-.4a1,1,0,0,1-.89.42c-.59,0-.95-.3-.95-.75s.26-.73,1-.73h.82v-.16c0-.45-.25-.69-.73-.69a1.29,1.29,0,0,0-.86.31l-.16-.26a1.64,1.64,0,0,1,1.05-.35A.92.92,0,0,1,408.53,148.41Zm-.35.83v-.42h-.81c-.5,0-.66.19-.66.46s.24.49.65.49A.82.82,0,0,0,408.18,149.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.87,148.52V150h-.35v-1.47c0-.55-.28-.83-.77-.83a.85.85,0,0,0-.91.94V150h-.35v-2.59h.33v.48a1.09,1.09,0,0,1,1-.5A1,1,0,0,1,411.87,148.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.58,148.72a1.27,1.27,0,0,1,1.33-1.31,1.14,1.14,0,0,1,1,.51l-.26.18a.9.9,0,0,0-.76-.39,1,1,0,0,0,0,2,.87.87,0,0,0,.76-.38l.26.18a1.14,1.14,0,0,1-1,.51A1.27,1.27,0,0,1,412.58,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.83,148.83h-2.17a1,1,0,0,0,1,.9,1,1,0,0,0,.79-.34l.2.23a1.26,1.26,0,0,1-1,.42,1.28,1.28,0,0,1-1.36-1.32,1.25,1.25,0,0,1,1.27-1.31,1.23,1.23,0,0,1,1.25,1.31Zm-2.17-.26h1.84a.91.91,0,0,0-.92-.86A.89.89,0,0,0,415.66,148.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.36,160.18c0,1.4-1.22,2.28-3.1,2.28s-3.07-.88-3.07-2.28a1.88,1.88,0,0,1,1.21-1.8,1.73,1.73,0,0,1-.94-1.59c0-1.29,1.13-2.1,2.8-2.1s2.83.81,2.83,2.1a1.75,1.75,0,0,1-1,1.59A1.89,1.89,0,0,1,392.36,160.18Zm-1.41,0c0-.75-.65-1.21-1.69-1.21s-1.66.46-1.66,1.21.63,1.22,1.66,1.22S391,160.9,391,160.14Zm-3.11-3.28c0,.64.54,1,1.42,1s1.45-.41,1.45-1-.58-1.07-1.45-1.07S387.84,156.18,387.84,156.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33,161.53a.89.89,0,1,1,.88.89A.87.87,0,0,1,393.33,161.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.49,160c0,1.33-1,2.43-3,2.43a4.7,4.7,0,0,1-2.83-.88l.59-1.09a3.54,3.54,0,0,0,2.22.75c1,0,1.6-.44,1.6-1.16s-.47-1.17-2-1.17h-1.82l.38-4.11h4.44V156H397.8l-.16,1.75h.72C400.6,157.72,401.49,158.69,401.49,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,158.57c0-2.48,1.35-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S402.3,161.05,402.3,158.57Zm4.89,0c0-1.82-.71-2.66-1.74-2.66s-1.74.84-1.74,2.66.71,2.67,1.74,2.67S407.19,160.4,407.19,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.55,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S409.55,161.05,409.55,158.57Zm4.9,0c0-1.82-.71-2.66-1.75-2.66s-1.74.84-1.74,2.66.72,2.67,1.74,2.67S414.45,160.4,414.45,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,160.89a1.22,1.22,0,0,1-.66-.2,1.2,1.2,0,0,1-.51-1.14l.49-3.57a.23.23,0,0,0-.06-.16l-2.66-2.42a1.18,1.18,0,0,1,.58-2l3.54-.64a.19.19,0,0,0,.14-.11l1.48-3.28a1.19,1.19,0,0,1,2.12-.07l1.7,3.17a.19.19,0,0,0,.15.09l3.57.4a1.19,1.19,0,0,1,.73,2l-2.49,2.6a.22.22,0,0,0,0,.17l.73,3.52a1.17,1.17,0,0,1-.43,1.17,1.15,1.15,0,0,1-1.24.14L365,158.94a.2.2,0,0,0-.17,0l-3.13,1.78A1.11,1.11,0,0,1,361.09,160.89Zm3.42-13.25h0a.17.17,0,0,0-.16.1L362.86,151a1.18,1.18,0,0,1-.87.68l-3.54.64a.17.17,0,0,0-.14.13.17.17,0,0,0,.05.19l2.66,2.42a1.19,1.19,0,0,1,.38,1l-.49,3.56a.21.21,0,0,0,.08.18.22.22,0,0,0,.2,0l3.12-1.79a1.19,1.19,0,0,1,1.1,0l3.24,1.57a.22.22,0,0,0,.2,0,.2.2,0,0,0,.06-.19l-.73-3.52a1.19,1.19,0,0,1,.31-1.06l2.48-2.6a.18.18,0,0,0-.11-.31l-3.57-.39a1.21,1.21,0,0,1-.92-.62l-1.7-3.17A.17.17,0,0,0,364.51,147.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.13,
    y: 138.93,
    width: 93.07,
    height: 31.13,
    rx: 3.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.85,167.79c-.14,0-.26-6.1-.26-13.62s.12-13.62.26-13.62.26,6.1.26,13.62S491,167.79,490.85,167.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M496.33,146.57h1.4a1.73,1.73,0,1,1,0,3.45h-1.4Zm1.38,3.13a1.41,1.41,0,1,0,0-2.81h-1v2.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.07,148.72a1.32,1.32,0,1,1,1.32,1.32A1.27,1.27,0,0,1,500.07,148.72Zm2.28,0a1,1,0,1,0-1,1A.95.95,0,0,0,502.35,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.15,147.43l-1,2.59h-.33L505,147.9l-.82,2.12h-.33l-1-2.59h.34l.81,2.2.83-2.2h.3l.83,2.2.82-2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.07,148.52V150h-.35v-1.47c0-.55-.28-.83-.78-.83a.85.85,0,0,0-.9.94V150h-.35v-2.59H508v.48a1.09,1.09,0,0,1,1-.5A1,1,0,0,1,510.07,148.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,146.36h.35V150H511Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.09,148.72a1.32,1.32,0,1,1,1.32,1.32A1.27,1.27,0,0,1,512.09,148.72Zm2.28,0a1,1,0,1,0-1,1A.94.94,0,0,0,514.37,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.39,148.41V150h-.34v-.4a1,1,0,0,1-.89.42c-.58,0-.94-.3-.94-.75s.25-.73,1-.73H517v-.16c0-.45-.25-.69-.73-.69a1.32,1.32,0,0,0-.87.31l-.16-.26a1.69,1.69,0,0,1,1.06-.35A.92.92,0,0,1,517.39,148.41Zm-.35.83v-.42h-.81c-.51,0-.67.19-.67.46s.24.49.66.49A.83.83,0,0,0,517,149.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.72,146.36V150h-.34v-.51a1.11,1.11,0,0,1-1,.53,1.32,1.32,0,0,1,0-2.63,1.15,1.15,0,0,1,1,.51v-1.56Zm-.35,2.36a1,1,0,1,0-1,1A.95.95,0,0,0,520.37,148.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.27,160a2.52,2.52,0,0,1-2.76,2.45c-2.06,0-3.27-1.33-3.27-3.76,0-2.59,1.51-4,3.7-4a3.83,3.83,0,0,1,2,.48l-.52,1.06a2.56,2.56,0,0,0-1.43-.36c-1.43,0-2.32.88-2.32,2.59v0a2.56,2.56,0,0,1,2-.79A2.36,2.36,0,0,1,502.27,160Zm-1.36.06c0-.79-.59-1.28-1.51-1.28a1.37,1.37,0,0,0-1.53,1.29c0,.72.56,1.28,1.57,1.28A1.31,1.31,0,0,0,500.91,160.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.07,161.53a.89.89,0,1,1,.88.89A.87.87,0,0,1,503.07,161.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.23,160c0,1.33-1,2.43-3,2.43a4.72,4.72,0,0,1-2.83-.88l.59-1.09a3.54,3.54,0,0,0,2.22.75c1,0,1.6-.44,1.6-1.16s-.46-1.17-2-1.17H506l.39-4.11h4.43V156h-3.25l-.16,1.75h.72C510.34,157.72,511.23,158.69,511.23,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S512,161.05,512,158.57Zm4.89,0c0-1.82-.71-2.66-1.74-2.66s-1.74.84-1.74,2.66.71,2.67,1.74,2.67S516.93,160.4,516.93,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.29,158.57c0-2.48,1.36-3.88,3.15-3.88s3.16,1.4,3.16,3.88-1.36,3.89-3.16,3.89S519.29,161.05,519.29,158.57Zm4.9,0c0-1.82-.71-2.66-1.75-2.66s-1.73.84-1.73,2.66.71,2.67,1.73,2.67S524.19,160.4,524.19,158.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.7,162.85a7.13,7.13,0,1,1,7.13-7.13A7.14,7.14,0,0,1,474.7,162.85Zm0-13.26a6.13,6.13,0,1,0,6.13,6.13A6.14,6.14,0,0,0,474.7,149.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.66,160.07a.46.46,0,0,1-.38-.18l-3-3.65a.52.52,0,0,1,.07-.71.5.5,0,0,1,.7.07l2.61,3.16,2.39-3.33a.5.5,0,0,1,.7-.12.51.51,0,0,1,.11.7l-2.76,3.86a.5.5,0,0,1-.39.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.62,159.94a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v7A.51.51,0,0,1,474.62,159.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.57,
    cy: 96.01,
    r: 2.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.9,
    cy: 96.01,
    r: 2.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.23,
    cy: 96.01,
    r: 2.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.03 29.23 550.98 29.21 551.55 27.23 551.6 27.25 551.03 29.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.84,409.24c0,.14-88.37.26-197.35.26s-197.37-.12-197.37-.26,88.35-.26,197.37-.26S590.84,409.1,590.84,409.24Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.74,414.73c-.14,0-.32-23.44-.4-52.34s0-52.34.11-52.34.32,23.43.4,52.34S654.88,414.73,654.74,414.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.61,356.08a2.84,2.84,0,0,1-.19.55c-.17.39-.38.9-.64,1.51l-.46,1.1-.48,1.33c-.17.47-.35,1-.55,1.52s-.34,1.13-.52,1.74a69.73,69.73,0,0,0-2,8.72,106.82,106.82,0,0,0-1.11,10.91,149.82,149.82,0,0,0,.56,19.92c.23,2.55.46,4.6.63,6,.08.67.14,1.21.18,1.64a2.05,2.05,0,0,1,0,.57,2.24,2.24,0,0,1-.13-.56l-.27-1.62c-.23-1.42-.52-3.47-.79-6a132.37,132.37,0,0,1-.72-20,101.75,101.75,0,0,1,1.15-11,68,68,0,0,1,2.11-8.75c.2-.61.37-1.2.57-1.74s.4-1.05.59-1.52.35-.92.51-1.33.36-.75.51-1.08l.73-1.48A2.39,2.39,0,0,1,670.61,356.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.79,337.13a5.54,5.54,0,0,1-.23.77l-.74,2.18c-.17.48-.35,1-.54,1.57s-.37,1.22-.58,1.89c-.41,1.36-.9,2.9-1.33,4.63-.22.87-.46,1.77-.71,2.71s-.44,1.94-.67,3c-.5,2-.86,4.25-1.31,6.57-.79,4.65-1.48,9.8-2,15.22s-.64,10.62-.71,15.35,0,9,.24,12.54c.06,1.79.17,3.4.27,4.81s.17,2.64.26,3.64.13,1.72.17,2.29a4.14,4.14,0,0,1,0,.81,4.94,4.94,0,0,1-.13-.8c-.07-.57-.16-1.33-.27-2.29s-.24-2.21-.35-3.62-.26-3-.34-4.82c-.24-3.57-.34-7.83-.35-12.57s.22-9.93.68-15.38,1.18-10.6,2-15.27c.48-2.32.85-4.54,1.37-6.58.24-1,.47-2,.7-3l.75-2.71c.45-1.73,1-3.27,1.4-4.62l.62-1.89c.21-.56.41-1.08.58-1.56l.84-2.15A4,4,0,0,1,668.79,337.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.24,418.87a.72.72,0,0,1,0-.27c0-.21,0-.48-.07-.81l-.21-3.1c-.17-2.74-.42-6.63-.72-11.42-.61-9.63-1.51-22.95-3.13-37.59-.83-7.32-1.79-14.27-2.79-20.57-.53-3.15-1-6.14-1.56-8.93s-1-5.38-1.54-7.74-1-4.49-1.41-6.36-.81-3.47-1.14-4.78-.56-2.29-.74-3c-.07-.32-.13-.58-.18-.79s-.05-.27-.05-.27a.73.73,0,0,1,.1.26c.06.2.13.46.23.77l.83,3c.36,1.3.79,2.9,1.23,4.77s1,4,1.49,6.35,1.08,4.94,1.6,7.74,1.06,5.78,1.6,8.92c1,6.31,2,13.27,2.83,20.6,1.63,14.65,2.47,28,3,37.62.26,4.83.45,8.73.56,11.43,0,1.32.08,2.36.11,3.11,0,.33,0,.59,0,.81S650.24,418.87,650.24,418.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.16,321.31c-.31-3.32-3.66-5.82-7-5.86s-6.44,2-8.48,4.61a26.54,26.54,0,0,0-4.08,9.06c-2.25,7.82-3.48,16-2.52,24.12s4.24,16,10,21.75c.94.93,2.16,1.85,3.46,1.58a4.06,4.06,0,0,0,1.82-1.13,54,54,0,0,0,17.52-41c-.09-3.08-.49-6.28-2.19-8.84s-5.67-5.27-8.57-4.25",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.26,294.72l-4.69,8.51c-.11.19-.26.42-.48.44s-.43-.22-.57-.42l-12.41-19.06,2.86-1.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M629.26,294.72l-4.69,8.51c-.11.19-.26.42-.48.44s-.43-.22-.57-.42l-12.41-19.06,2.86-1.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M654.45,310.05l-42.35-25c-.44-.26-.91-.56-1-1a2,2,0,0,1,.76-1.7,29.17,29.17,0,0,1,22.63-8.89,25.84,25.84,0,0,1,20.46,12.72c4.09,7.31,4.22,17-.46,23.9",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.2,277.08a2.22,2.22,0,0,1,.55-.07c.37,0,.91-.08,1.6-.08a32.19,32.19,0,0,1,5.88.47,34.33,34.33,0,0,1,27.41,24.8,31,31,0,0,1,1.05,5.8,12,12,0,0,1,.07,1.24,2,2,0,0,1-.33.92,7.11,7.11,0,0,0,.07-2.14,36.84,36.84,0,0,0-1.2-5.72,34.64,34.64,0,0,0-27.13-24.55,36.49,36.49,0,0,0-5.82-.62C619,277.1,618.2,277.12,618.2,277.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.71,292.8a10.25,10.25,0,0,1-2.14,1c-1.35.53-3.23,1.21-5.34,1.88s-4,1.21-5.45,1.55a10.23,10.23,0,0,1-2.31.44,11.8,11.8,0,0,1,2.21-.79l5.4-1.68,5.37-1.74A11.48,11.48,0,0,1,648.71,292.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.05,274.88a18.64,18.64,0,0,1,.5,4.73,17.94,17.94,0,0,1-.27,4.74,30.75,30.75,0,0,1-.24-4.73A27.7,27.7,0,0,1,642.05,274.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.73,284.58a19.34,19.34,0,0,1,3.07-1.08c1.93-.59,4.61-1.34,7.59-2.06s5.72-1.28,7.7-1.62a18.7,18.7,0,0,1,3.23-.44,23,23,0,0,1-3.16.79c-2,.44-4.67,1-7.65,1.76s-5.66,1.41-7.61,1.92A22.68,22.68,0,0,1,611.73,284.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.58,314.11c-3.64-2.76-7.49-3.31-12.06-3.13a37.13,37.13,0,0,0-13.2,3.41c-7.14,3.13-13.85,7.74-18.12,14.26s-5.75,15.17-2.56,22.28a3.13,3.13,0,0,0,1.45,1.75,3.38,3.38,0,0,0,2.39-.18c8.12-2.65,16.3-5.32,23.77-9.47s14.26-9.92,18.27-17.47a15.08,15.08,0,0,0,1.93-5.79,7.22,7.22,0,0,0-1.87-5.66",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.65,313.25a2.37,2.37,0,0,1-.58.24l-1.7.59-1.23.41c-.45.16-.93.36-1.44.56-1,.41-2.22.83-3.48,1.44l-2,.91c-.69.31-1.38.71-2.11,1.08-1.48.72-3,1.65-4.55,2.58a71.53,71.53,0,0,0-17.92,15.77c-1.13,1.45-2.24,2.81-3.14,4.18-.46.68-.94,1.31-1.34,1.95L596,344.82c-.76,1.17-1.33,2.3-1.87,3.27-.26.49-.52.93-.74,1.36l-.56,1.17c-.33.66-.6,1.19-.8,1.61a3,3,0,0,1-.31.55,2.57,2.57,0,0,1,.22-.59l.71-1.66.52-1.19c.21-.43.46-.89.71-1.38.52-1,1.07-2.13,1.81-3.32.37-.6.74-1.23,1.14-1.89s.87-1.29,1.32-2c.9-1.39,2-2.77,3.13-4.24a75.42,75.42,0,0,1,8.33-8.72,76.75,76.75,0,0,1,9.7-7.15c1.61-.93,3.11-1.84,4.6-2.56.74-.36,1.44-.75,2.14-1.06l2-.88c1.27-.59,2.48-1,3.52-1.38.52-.19,1-.37,1.46-.52l1.25-.37,1.73-.5A3.57,3.57,0,0,1,636.65,313.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.2,328.66a85.6,85.6,0,0,1-8.86,2.86,83.61,83.61,0,0,1-9,2.36A86.88,86.88,0,0,1,599.2,331,87.77,87.77,0,0,1,608.2,328.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.83,348.21a14.64,14.64,0,0,1-.19-2.76c0-1.7-.06-4.06,0-6.67s.21-5,.35-6.66a13.61,13.61,0,0,1,.35-2.74,15.87,15.87,0,0,1,0,2.76c-.06,1.87-.13,4.14-.21,6.66s-.12,4.78-.16,6.65A16.05,16.05,0,0,1,607.83,348.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.58,339.68c-.14,0-.58-4.78-1-10.71s-.63-10.73-.49-10.74.58,4.78,1,10.71S624.72,339.67,624.58,339.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.73,317.77a15.78,15.78,0,0,1,2.84-.09c1.75,0,4.17.06,6.84.15s5.09.2,6.83.3a16.07,16.07,0,0,1,2.83.28,16.26,16.26,0,0,1-2.83.08c-1.76,0-4.17-.06-6.85-.15s-5.08-.2-6.83-.3A16.83,16.83,0,0,1,603.73,317.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.94,376.1a2.09,2.09,0,0,1-.06-.57c0-.42,0-1-.08-1.62-.06-1.42-.08-3.47,0-6s.22-5.55.52-8.89.81-7,1.49-10.8,1.55-7.4,2.41-10.64,1.79-6.12,2.64-8.51,1.58-4.32,2.14-5.62c.26-.62.48-1.11.65-1.51a3.44,3.44,0,0,1,.25-.51,2.15,2.15,0,0,1-.16.55c-.14.4-.33.91-.55,1.54-.5,1.32-1.19,3.26-2,5.66s-1.67,5.29-2.54,8.52-1.66,6.82-2.36,10.61-1.17,7.44-1.52,10.76-.54,6.32-.63,8.85-.14,4.57-.14,6c0,.67,0,1.21,0,1.63A3.09,3.09,0,0,1,643.94,376.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.17,348.37a11.45,11.45,0,0,1-1.69,1.86c-1.09,1.09-2.65,2.56-4.42,4.11s-3.44,2.91-4.67,3.85a11.8,11.8,0,0,1-2,1.44,11.9,11.9,0,0,1,1.83-1.71l4.55-4,4.52-4A12.81,12.81,0,0,1,646.17,348.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.58,359.17a18.69,18.69,0,0,1-1.8-2.49l-4.19-6.11-4.27-6.05a19.34,19.34,0,0,1-1.71-2.55,18.43,18.43,0,0,1,2,2.34c1.17,1.49,2.74,3.59,4.4,6s3.08,4.58,4.07,6.2A18.62,18.62,0,0,1,659.58,359.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.55,325.21c.08.12-4.37,3.12-9.94,6.7s-10.14,6.38-10.22,6.26,4.38-3.11,10-6.69S652.48,325.09,652.55,325.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.11,338.76a81.76,81.76,0,0,1-6.73-6.22A84.46,84.46,0,0,1,652,326a167.6,167.6,0,0,1,13.12,12.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.27,338.49l3.82-.32a18.78,18.78,0,0,0,7.72-2.36,30.29,30.29,0,0,1,3.6-1.81c4.72-1.89,10-1.55,15.08-1.81a62.32,62.32,0,0,0,24-6.14,2.28,2.28,0,0,0,1-.94c.78-1.43-.68-2.71-1.93-3.48-6.44-4-13-8-20.3-10s-15.59-1.64-21.83,2.65c-7.31,5-10,15.38-11.21,24.17",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.62,324.64a4.51,4.51,0,0,1-.64-.31l-1.82-.94c-1.57-.83-3.83-2.05-6.69-3.42a61.46,61.46,0,0,0-10.36-4,34.13,34.13,0,0,0-13.42-1.09,23,23,0,0,0-12.24,5.25,27.37,27.37,0,0,0-6.38,9,74.16,74.16,0,0,0-2.77,7l-.68,1.92a3.89,3.89,0,0,1-.27.67,6,6,0,0,1,.17-.7c.15-.49.35-1.14.59-2a64.51,64.51,0,0,1,2.64-7.05,27,27,0,0,1,6.39-9.16,23.28,23.28,0,0,1,12.48-5.41,34.11,34.11,0,0,1,13.62,1.15,59.28,59.28,0,0,1,10.39,4.12c2.85,1.41,5.09,2.68,6.63,3.56l1.77,1A3.24,3.24,0,0,1,723.62,324.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.44,329.57c-.07.11-5.07-3.12-11.16-7.22s-11-7.53-10.89-7.65,5.08,3.12,11.17,7.22S714.52,329.45,714.44,329.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.11,314.44a19.5,19.5,0,0,1-7.35.6,24.73,24.73,0,0,1,3.67-.37A24.42,24.42,0,0,1,709.11,314.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.22,311.59a9.41,9.41,0,0,1-1.64,2.56,11,11,0,0,1-2.07,2.36,9.54,9.54,0,0,1,1.64-2.56A10.72,10.72,0,0,1,687.22,311.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.7,332.51a12.62,12.62,0,0,1-2.4-1.3c-1.45-.88-3.4-2.16-5.48-3.68s-3.93-2.94-5.25-4a15,15,0,0,1-2.08-1.78,14,14,0,0,1,2.3,1.49l5.32,3.87c2.08,1.51,4,2.84,5.38,3.79A16.62,16.62,0,0,1,691.7,332.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.9,354.73c-3.65-1-8,2.59-8.75,6.28s.64,7.48,2.26,10.88a55.42,55.42,0,0,0,15.08,19.73c6.53,5.2,14.7,8.53,23,8.49-1.54-7.16.41-14.64-.45-21.92a28.49,28.49,0,0,0-25.24-25c-2.33-.25-5-.62-6,1.53",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.54,400.11a3,3,0,0,1-.52-.25,9,9,0,0,1-1.36-.91,14.28,14.28,0,0,1-3.6-4.82c-.58-1.13-1.23-2.35-1.87-3.71s-1.27-2.81-2-4.33a41.16,41.16,0,0,0-2.41-4.64,35.24,35.24,0,0,0-3.32-4.51c-2.49-2.93-5.17-5.47-7.49-7.89a51.54,51.54,0,0,1-5.72-6.86,25.2,25.2,0,0,1-2.79-5.33c-.24-.68-.4-1.2-.49-1.57a2.08,2.08,0,0,1-.11-.56s.25.75.78,2a27.86,27.86,0,0,0,2.91,5.21,53.92,53.92,0,0,0,5.75,6.73c2.34,2.4,5,4.93,7.55,7.89a36.49,36.49,0,0,1,3.36,4.58,41.91,41.91,0,0,1,2.41,4.7c.67,1.53,1.31,3,1.92,4.36s1.24,2.58,1.8,3.72a14.64,14.64,0,0,0,3.41,4.83C704.85,399.72,705.57,400.06,705.54,400.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.69,394.16a10.86,10.86,0,0,1,.33-2.46c.29-1.5.76-3.56,1.39-5.81s1.31-4.25,1.85-5.68a10.92,10.92,0,0,1,1-2.26,12.83,12.83,0,0,1-.65,2.38c-.45,1.46-1.07,3.47-1.7,5.7s-1.15,4.27-1.53,5.75A13.37,13.37,0,0,1,686.69,394.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.85,376.58a15.13,15.13,0,0,1-2.57-.59c-1.57-.41-3.74-1-6.15-1.52s-4.62-1-6.21-1.26a16.25,16.25,0,0,1-2.58-.57,12.1,12.1,0,0,1,2.63.21c1.62.21,3.84.58,6.27,1.13s4.59,1.17,6.14,1.67A13,13,0,0,1,704.85,376.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.16,381.69a14.22,14.22,0,0,1,.39-2.84c.32-1.74.83-4.14,1.51-6.75s1.41-5,2-6.63a14.18,14.18,0,0,1,1.05-2.67,17.55,17.55,0,0,1-.7,2.78c-.49,1.7-1.15,4-1.83,6.65s-1.25,5-1.66,6.69A18.33,18.33,0,0,1,673.16,381.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.49,361.27a101.54,101.54,0,0,1-10.17-.83c-5.6-.59-10.13-1.18-10.11-1.32s4.56.23,10.16.82A101.2,101.2,0,0,1,696.49,361.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.8,
    y: 406.72,
    width: 71.23,
    height: 9.79,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.16,416.63H621.68v-10h71.48Zm-71.24-.25h71v-9.54h-71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.4 413.25 638.66 463.83 676.6 463.83 686.51 416.51 628.4 413.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.4 459.05 633.87 466.57 679.99 466.57 686.51 459.05 628.4 459.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.15,416.47c0,.14-16,.25-35.73.25s-35.74-.11-35.74-.25,16-.26,35.74-.26S693.15,416.33,693.15,416.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682,437.06c0,.14-10.78.25-24.08.25s-24.08-.11-24.08-.25,10.78-.26,24.08-.26S682,436.92,682,437.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.6,440c0,.14-10.59.25-23.66.25s-23.65-.11-23.65-.25,10.59-.25,23.65-.25S681.6,439.86,681.6,440Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.44,434.63c0,.14-11.15.25-24.9.25s-24.91-.11-24.91-.25,11.15-.25,24.91-.25S682.44,434.49,682.44,434.63Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-190"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.68,
    y: 165.79,
    width: 183.68,
    height: 84.91,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.37,250.71s0-.52,0-1.52,0-2.48,0-4.41c0-3.88,0-9.58-.05-16.92,0-14.67-.06-35.88-.1-62.07l.19.19-183.67.07h0l.26-.26c0,29.87,0,58.59,0,84.92l-.25-.25,131.88.12,38.1.06,10.17,0h2.63l.91,0h-.88l-2.6,0-10.12,0-38,.06L524.68,251h-.24v-.24c0-26.33,0-55.05,0-84.92v-.26h.28l183.67.07h.19v.19c0,26.24-.08,47.49-.11,62.18,0,7.32,0,13,0,16.88,0,1.92,0,3.38,0,4.38S708.37,250.71,708.37,250.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.61,224.45v2.68h-.28v-2.44h-.63v-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.25,225.79c0-.86.45-1.37,1.07-1.37s1.07.51,1.07,1.37-.45,1.36-1.07,1.36S538.25,226.64,538.25,225.79Zm1.86,0c0-.72-.32-1.11-.79-1.11s-.79.39-.79,1.11.32,1.11.79,1.11S540.11,226.5,540.11,225.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.69,210.21v.25h-1.88v-.2l1.12-1.09c.3-.3.36-.48.36-.66s-.22-.5-.63-.5a.9.9,0,0,0-.73.3l-.2-.17a1.2,1.2,0,0,1,.95-.39c.55,0,.89.28.89.73a1.12,1.12,0,0,1-.44.84l-.91.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,209.12c0-.86.45-1.37,1.07-1.37s1.07.51,1.07,1.37-.45,1.36-1.07,1.36S539,210,539,209.12Zm1.86,0c0-.72-.33-1.11-.79-1.11s-.79.39-.79,1.11.32,1.11.79,1.11S540.89,209.83,540.89,209.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.64,193c0,.45-.33.79-1,.79a1.4,1.4,0,0,1-1-.34l.13-.22a1.2,1.2,0,0,0,.83.31c.45,0,.69-.21.69-.54s-.22-.53-.72-.53h-.19v-.21l.74-.93h-1.37v-.24h1.72v.19l-.75,1C538.35,192.29,538.64,192.59,538.64,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,192.45c0-.86.45-1.37,1.07-1.37s1.07.51,1.07,1.37-.45,1.36-1.07,1.36S539,193.3,539,192.45Zm1.86,0c0-.72-.33-1.11-.79-1.11s-.79.39-.79,1.11.32,1.11.79,1.11S540.89,193.16,540.89,192.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.44,234.58c0-.85.45-1.36,1.07-1.36s1.07.51,1.07,1.36-.45,1.37-1.07,1.37S549.44,235.44,549.44,234.58Zm1.86,0c0-.71-.32-1.11-.79-1.11s-.79.4-.79,1.11.32,1.11.79,1.11S551.3,235.3,551.3,234.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.29,233.24v2.68H569v-2.43h-.63v-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.2,235.68v.24h-1.88v-.19l1.12-1.09c.3-.3.36-.48.36-.67s-.22-.5-.63-.5a.9.9,0,0,0-.73.3l-.2-.17a1.22,1.22,0,0,1,1-.38c.54,0,.89.27.89.72a1.1,1.1,0,0,1-.44.84l-.91.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,235.15c0,.45-.32.8-1,.8a1.41,1.41,0,0,1-1-.35l.14-.22a1.16,1.16,0,0,0,.83.31c.44,0,.69-.2.69-.54s-.23-.53-.73-.53h-.19v-.2l.75-.93h-1.37v-.25h1.72v.2l-.76.95C609.69,234.42,610,234.72,610,235.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.31,235.22h-.54v.7h-.28v-.7H628V235l1.42-1.78h.31L628.34,235h1.16v-.62h.27V235h.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.67,235.13c0,.46-.31.82-1,.82a1.4,1.4,0,0,1-1-.35l.13-.22a1.18,1.18,0,0,0,.83.31c.45,0,.7-.22.7-.55s-.22-.55-.9-.55h-.57l.14-1.35h1.46v.25h-1.22l-.09.85h.34C649.37,234.34,649.67,234.66,649.67,235.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.7,235.12a.85.85,0,0,1-.92.83c-.71,0-1.1-.5-1.1-1.35s.5-1.38,1.23-1.38a1.22,1.22,0,0,1,.63.14l-.11.23a.86.86,0,0,0-.52-.13c-.58,0-.95.37-.95,1.1,0,.06,0,.14,0,.22a.86.86,0,0,1,.82-.46A.81.81,0,0,1,669.7,235.12Zm-.27,0c0-.35-.26-.58-.68-.58a.62.62,0,0,0-.69.59c0,.29.25.57.71.57A.59.59,0,0,0,669.43,235.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.4,233.24v.2l-1.12,2.48H688l1.11-2.43h-1.38v.5h-.28v-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.55,225.92c0,.14-31,.26-69.3.26s-69.31-.12-69.31-.26,31-.26,69.31-.26S689.55,225.77,689.55,225.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.55,209.16c0,.14-31,.26-69.3.26s-69.31-.12-69.31-.26,31-.26,69.31-.26S689.55,209,689.55,209.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.55,192.4c0,.15-31,.26-69.3.26s-69.31-.11-69.31-.26,31-.26,69.31-.26S689.55,192.26,689.55,192.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.94,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,550.94,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.87,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,570.87,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.79,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,590.79,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.72,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,610.72,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.65,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,630.65,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.51,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,670.51,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.58,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,650.58,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.44,225.67a.89.89,0,1,1-.89-.89A.89.89,0,0,1,690.44,225.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560,225.92a.59.59,0,1,1-.58-.59A.58.58,0,0,1,560,225.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,225.92a.58.58,0,0,1-.58.58.59.59,0,1,1,0-1.17A.58.58,0,0,1,580,225.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 599.44,
    cy: 225.92,
    r: 0.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 619.45,
    cy: 225.92,
    r: 0.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.45,
    cy: 225.92,
    r: 0.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660,225.92a.59.59,0,0,1-.59.58.59.59,0,0,1,0-1.17A.59.59,0,0,1,660,225.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680,225.92a.59.59,0,1,1-.58-.59A.58.58,0,0,1,680,225.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.16,218.51a2.19,2.19,0,1,1-2.18-2.18A2.19,2.19,0,0,1,572.16,218.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,208.25a2.19,2.19,0,1,1-2.19-2.18A2.19,2.19,0,0,1,589.55,208.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.13,209.16a2.19,2.19,0,1,1-2.19-2.18A2.18,2.18,0,0,1,611.13,209.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.19,190.51a2.18,2.18,0,1,1-2.18-2.18A2.18,2.18,0,0,1,632.19,190.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.87,202.37a2.18,2.18,0,1,1-2.18-2.18A2.17,2.17,0,0,1,651.87,202.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.8,205.53a2.18,2.18,0,1,1-2.18-2.18A2.19,2.19,0,0,1,671.8,205.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.44,218.51a3.43,3.43,0,0,1-.52,0,12.59,12.59,0,0,1-1.48-.2,11.32,11.32,0,0,1-5.19-2.46,10.85,10.85,0,0,1-2.54-3.32A25.25,25.25,0,0,0,678,208.4a8.87,8.87,0,0,0-4.51-3.14,5.71,5.71,0,0,0-3,.11,8,8,0,0,0-2.76,1.56c-1.7,1.42-2.95,3.44-4.6,5.27a9.11,9.11,0,0,1-3,2.33,6,6,0,0,1-3.93.32,4.94,4.94,0,0,1-3-2.75,18.89,18.89,0,0,1-1.29-4,23.18,23.18,0,0,0-1.19-4,3.21,3.21,0,0,0-1.27-1.53,4.27,4.27,0,0,0-2-.39,33.65,33.65,0,0,0-4.38.78,13.5,13.5,0,0,1-2.31.26,5.22,5.22,0,0,1-2.35-.46,4.87,4.87,0,0,1-1.87-1.56,11.72,11.72,0,0,1-1.14-2.12c-.63-1.48-1.05-3-1.62-4.51a10.69,10.69,0,0,0-1.06-2.11A3.84,3.84,0,0,0,631,191c-.18-.05-.36-.12-.54-.16l-.58-.06a2,2,0,0,0-1.06.22,4.44,4.44,0,0,0-1.6,1.67,20.72,20.72,0,0,0-1.85,4.58c-.47,1.61-.87,3.25-1.26,4.91-.64,2.75-1.21,5.49-1.91,8.17a41.27,41.27,0,0,1-1.23,4,10.4,10.4,0,0,1-2.07,3.6,2.87,2.87,0,0,1-2,.87,4,4,0,0,1-2-.61,9.52,9.52,0,0,1-2.83-2.86,35.18,35.18,0,0,1-3.42-6.94,16,16,0,0,0-3.82-6.15,7.14,7.14,0,0,0-6.4-1.56,10.81,10.81,0,0,0-3,1.34,20.52,20.52,0,0,0-2.66,1.93,35.42,35.42,0,0,0-4.45,4.47h0a47.21,47.21,0,0,1-6.58,5.47,31.86,31.86,0,0,1-6.74,3.65,14.7,14.7,0,0,1-6.6,1.1,22.62,22.62,0,0,1-5.5-1.33,52,52,0,0,1-7.14-3.26c-.79-.43-1.38-.78-1.78-1a6.2,6.2,0,0,1-.59-.39l.62.33,1.81,1a55.32,55.32,0,0,0,7.16,3.15,22.63,22.63,0,0,0,5.44,1.27,14.59,14.59,0,0,0,6.46-1.13,31.24,31.24,0,0,0,6.64-3.65,47.35,47.35,0,0,0,6.5-5.44h0a35,35,0,0,1,4.49-4.55,21.87,21.87,0,0,1,2.71-2,11.18,11.18,0,0,1,3.17-1.4,7.62,7.62,0,0,1,6.83,1.64,16.62,16.62,0,0,1,4,6.32,34.48,34.48,0,0,0,3.37,6.84,9.11,9.11,0,0,0,2.68,2.71,3.49,3.49,0,0,0,1.76.54,2.4,2.4,0,0,0,1.61-.73,9.88,9.88,0,0,0,1.94-3.41c.47-1.26.85-2.58,1.21-3.91.7-2.66,1.26-5.4,1.9-8.16.39-1.66.79-3.31,1.27-4.94a21.08,21.08,0,0,1,1.91-4.7,4.82,4.82,0,0,1,1.81-1.86,2.52,2.52,0,0,1,1.31-.27l.66.06c.21,0,.42.13.63.19a4.41,4.41,0,0,1,2,1.63,10.47,10.47,0,0,1,1.11,2.22c.58,1.52,1,3.06,1.62,4.49s1.38,2.85,2.75,3.43a7.19,7.19,0,0,0,4.36.16,34.62,34.62,0,0,1,4.46-.77,4.53,4.53,0,0,1,2.25.46,3.66,3.66,0,0,1,1.48,1.74,23.22,23.22,0,0,1,1.2,4.13,19.24,19.24,0,0,0,1.25,3.89,4.51,4.51,0,0,0,2.72,2.54,5.61,5.61,0,0,0,3.64-.3,8.73,8.73,0,0,0,2.86-2.21c1.63-1.79,2.9-3.82,4.66-5.28a8.42,8.42,0,0,1,2.9-1.62,6.18,6.18,0,0,1,3.16-.09,9.07,9.07,0,0,1,4.65,3.28,24.21,24.21,0,0,1,2.67,4.2,10.56,10.56,0,0,0,2.46,3.27,11.43,11.43,0,0,0,5.07,2.52,12.29,12.29,0,0,0,1.47.24Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.37,180.92c0,.15-7.74.26-17.28.26s-17.28-.11-17.28-.26,7.74-.26,17.28-.26S572.37,180.78,572.37,180.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.52,439.83l1,17.74s18.17,3.42,18.68,6.68L150.14,469l-2.76-27.58Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,457.09a1.41,1.41,0,0,0-.82,1.69,1.36,1.36,0,0,0,1.67.83,1.5,1.5,0,0,0,.86-1.8,1.4,1.4,0,0,0-1.84-.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,469l-.27-2.75,32.38-3.87s2,.87,2.08,1.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,457.34c0,.17-.82.32-1.59.94s-1.15,1.37-1.31,1.31,0-1,.95-1.77S166.13,457.18,166.11,457.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.85,458.49c.06.16-.64.51-1.15,1.27s-.59,1.53-.76,1.54-.36-.93.28-1.87S169.83,458.33,169.85,458.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,462.6c-.15,0-.47-.76-.12-1.72s1.09-1.4,1.17-1.27-.35.67-.62,1.46S172.47,462.57,172.31,462.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,453.32c0,.16-.84,0-1.78.16s-1.66.52-1.76.39.56-.8,1.67-1S165.49,453.19,165.42,453.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.15,449.75a3.19,3.19,0,0,1-1.72.15,7.43,7.43,0,0,1-1.85-.38,6.94,6.94,0,0,1-1-.43,2,2,0,0,1-.56-.35.74.74,0,0,1-.16-.89.92.92,0,0,1,.7-.45,2.25,2.25,0,0,1,.65,0,7.09,7.09,0,0,1,1.1.26,6.34,6.34,0,0,1,1.69.89c.86.67,1.2,1.27,1.14,1.3s-.51-.42-1.37-.95a6.79,6.79,0,0,0-1.62-.72,6.35,6.35,0,0,0-1-.21c-.37-.06-.68,0-.76.13s0,.09.06.19a1.53,1.53,0,0,0,.41.26,8.09,8.09,0,0,0,1,.43,9.45,9.45,0,0,0,1.72.48A11.79,11.79,0,0,1,165.15,449.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,450c-.06,0-.45-.54-.61-1.62a5.61,5.61,0,0,1,0-1.9,7.15,7.15,0,0,1,.34-1.09,1.44,1.44,0,0,1,1-1,.82.82,0,0,1,.76.41,2.19,2.19,0,0,1,.24.62,3.83,3.83,0,0,1,.11,1.15,3.93,3.93,0,0,1-.57,1.85c-.58,1-1.26,1.22-1.28,1.16s.49-.45.92-1.36a4.06,4.06,0,0,0,.39-1.66,3.37,3.37,0,0,0-.13-1c-.09-.36-.25-.64-.38-.59s-.44.31-.55.62a5.34,5.34,0,0,0-.34,1,6.55,6.55,0,0,0-.17,1.74C164.8,449.37,165,450,165,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,437.55l-4,21.94-8.14,16.45a2.29,2.29,0,0,0,1.18,3.12h0a2.28,2.28,0,0,0,2.08-.17c4-2.52,18.61-11.85,18.81-13.47.23-1.88,5.71-22.87,5.71-22.87Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.44,479.06l21.19-15.12-.19.93a3.41,3.41,0,0,1-1.24,2c-1.72,1.35-6.55,5-17.61,12a2.28,2.28,0,0,1-2.15.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.59,457.55a1.38,1.38,0,0,0-.74,1.69,1.33,1.33,0,0,0,1.68.74,1.46,1.46,0,0,0,.76-1.8,1.37,1.37,0,0,0-1.82-.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.38,470.54a6.67,6.67,0,0,0-1.57-2.09,6.87,6.87,0,0,0-2.41-1c0-.06.3-.17.83-.14a3.52,3.52,0,0,1,1.88.75,3.59,3.59,0,0,1,1.2,1.64C83.47,470.2,83.44,470.53,83.38,470.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,473.14c-.12.08-.68-.78-1.74-1.33a17.74,17.74,0,0,0-2.08-.71,2.52,2.52,0,0,1,2.31.28C80.93,472,81.35,473.11,81.23,473.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,467.38a21.24,21.24,0,0,0-2.55-2.24,24.15,24.15,0,0,0-3.08-1.42A6.25,6.25,0,0,1,87,467.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.81,460.81c-.09.12-1.19-.63-2.75-1s-2.88-.25-2.9-.4a4.4,4.4,0,0,1,3-.07A4.48,4.48,0,0,1,88.81,460.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,454.4a11.26,11.26,0,0,0-2.83-1.13,11.25,11.25,0,0,0-3,.14c0-.05.27-.28.83-.47a4.92,4.92,0,0,1,2.3-.15,4.79,4.79,0,0,1,2.12.9C90,454.05,90.17,454.36,90.13,454.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,452.06a1.81,1.81,0,0,1,.14-.83,5.66,5.66,0,0,1,1.09-2,2.67,2.67,0,0,1,1.34-1,.93.93,0,0,1,1,.41,1.52,1.52,0,0,1,.14,1.06A3.23,3.23,0,0,1,87.91,452a3.74,3.74,0,0,1-3.21-2.66,1.33,1.33,0,0,1,.15-1.07.92.92,0,0,1,1-.28,3.15,3.15,0,0,1,1.29,1.05,6.53,6.53,0,0,1,1.14,2,1.88,1.88,0,0,1,.18.82,10.17,10.17,0,0,0-1.58-2.6,3,3,0,0,0-1.15-.88.47.47,0,0,0-.55.15.88.88,0,0,0-.06.71A3.32,3.32,0,0,0,88,451.54a2.8,2.8,0,0,0,2.89-2,1.07,1.07,0,0,0-.07-.74.5.5,0,0,0-.53-.24,2.41,2.41,0,0,0-1.15.82A8.56,8.56,0,0,0,87.59,452.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.74,289.36c-.23,0-7.51,166.13-7.51,166.13h22.21l10.8-90,5.59-68.78,11.52,64.39,14,91.65,22.35-4.8L152.53,284.25l-31.69-17.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,171.59l21-1.68c.13-2.45,0-11.93,0-11.93s8.73-1.36,8.84-10.1S136,119.09,136,119.09h0a30.35,30.35,0,0,0-30.5,3.83l-1.3,1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,157.85a20.3,20.3,0,0,1-11.39-3.24s2.69,6.29,11.41,5.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,133c-.15-.07-6-1.78-5.81,4.19s6.15,4.55,6.15,4.38S105.28,133,105.28,133Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,139.34s-.1.07-.27.16a1,1,0,0,1-.78,0,2.56,2.56,0,0,1-1.26-2.27,3.32,3.32,0,0,1,.24-1.5,1.19,1.19,0,0,1,.76-.82.53.53,0,0,1,.62.26c.09.17,0,.29.08.3s.13-.11.07-.35a.68.68,0,0,0-.24-.37.8.8,0,0,0-.58-.13,1.45,1.45,0,0,0-1.06,1,3.49,3.49,0,0,0-.31,1.67,2.71,2.71,0,0,0,1.6,2.53,1.11,1.11,0,0,0,1-.19C103.72,139.48,103.75,139.35,103.72,139.34Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.24,133.39a1.24,1.24,0,0,1-1.2,1.26,1.2,1.2,0,0,1-1.28-1.13,1.24,1.24,0,0,1,1.2-1.26A1.19,1.19,0,0,1,134.24,133.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,131.38c-.15.16-1.1-.54-2.44-.54s-2.33.68-2.47.51.08-.36.51-.68a3.45,3.45,0,0,1,2-.61,3.33,3.33,0,0,1,1.94.63C134.29,131,134.43,131.3,134.35,131.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,133.39a1.26,1.26,0,0,1-1.2,1.26,1.2,1.2,0,0,1-1.29-1.13,1.26,1.26,0,0,1,1.2-1.26A1.19,1.19,0,0,1,121.19,133.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.16,131.63c-.16.16-1.11-.54-2.45-.54s-2.32.68-2.47.51.09-.36.52-.67a3.43,3.43,0,0,1,3.92,0C121.09,131.26,121.23,131.55,121.16,131.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,141.58a9.18,9.18,0,0,1,2.18-.39c.34,0,.66-.1.72-.34a1.69,1.69,0,0,0-.23-1l-1-2.61a45.16,45.16,0,0,1-2.28-6.83,43.68,43.68,0,0,1,2.82,6.63l1,2.62a2,2,0,0,1,.17,1.35.87.87,0,0,1-.56.5,2.17,2.17,0,0,1-.58.08A8.58,8.58,0,0,1,126,141.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,142.51c.21,0,.22,1.44,1.46,2.48s2.8.87,2.81,1.08-.34.28-1,.3a3.65,3.65,0,0,1-2.34-.82,3.16,3.16,0,0,1-1.14-2.08C121.81,142.86,122,142.5,122.08,142.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,126.37c-.13.36-1.47.19-3,.38s-2.84.62-3,.29c-.1-.16.12-.5.64-.85a5.07,5.07,0,0,1,2.26-.8,5.2,5.2,0,0,1,2.39.28C121.27,125.91,121.56,126.19,121.5,126.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,127.49c-.24.31-1.16,0-2.28,0s-2.05.21-2.27-.11c-.09-.15.06-.46.47-.75a3.27,3.27,0,0,1,3.66.12C133.83,127,134,127.34,133.86,127.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,113.57a3.24,3.24,0,0,0-1.19-2.88,2.3,2.3,0,0,0-3,.22,2.67,2.67,0,0,0-2.3-3.23c-1.42-.09-2.64,1-4,1.36a6.45,6.45,0,0,1-4.07-.47c-1.3-.52-2.51-1.24-3.81-1.72a11.17,11.17,0,0,0-14.29,6.56,5,5,0,0,0-5.26,2,8.16,8.16,0,0,0-1.25,5.73,18.34,18.34,0,0,0,1,3.92c0,.12,0,.23,0,.34.09,4.8.64,10.44,2.69,10.47,3.57.06,2.72-6.67,2.72-6.67,4.38-1.69,2.75-8.26,3.84-9.26s3.39-3.31,12.57,1.38a17.77,17.77,0,0,0,10.89,1.18l.23,0h.05l.08,0a8,8,0,0,0,2.35-1,4.64,4.64,0,0,0,1.94-2.15,2.56,2.56,0,0,0-.5-2.74A5.53,5.53,0,0,0,140.26,113.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93,240.83a2.23,2.23,0,0,1,.22.24c.38.5,1,1.78.35,4a74.25,74.25,0,0,1-2.88,7.25s.7,3,0,3.69-12.09,0-12.09,0-2-1.09-.46-2h8",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,175.74s-9.85,3.12-14.44,22.57C67.71,212.59,58.16,241,60.58,245.53c3,5.62,37.83,14.59,37.83,14.59l3-13.3L83.93,235l9.34-31.58S94.33,177.2,85.53,175.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,212c0,1.49,4.44,31.13,4.44,31.13l-8.82,48.18,34.16,1.8,3.8-20.78,4.71,20.78,30.74-7.47-7.88-32.87,3-42.26-3.3-35.11L136.5,171.1,130,163.47l-10.55,6.58-13-7.8-4.12,5.62-16.77,7.87C83.86,178.8,88.29,212,88.29,212Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,162.25l-.43,9.34,18,47.79,7.26-46.95-2.36-9h0l-9.42,6.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,175.41s8.61,7,11.53,15.18,7.73,19.08,7.73,19.08h-16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,221.19a2.36,2.36,0,0,1-.43-.51L122,219.14c-1-1.41-2.44-3.35-4.18-5.73l-13.61-19-2.25-3.16-.1-.15.1-.15c1.23-1.78,2.43-3.5,3.57-5.16l.05.34-7.92-5.91-.12-.09,0-.15c1.41-3.67,2.57-6.69,3.41-8.86l1-2.42a4.93,4.93,0,0,1,.38-.84,5,5,0,0,1-.26.88c-.22.62-.51,1.44-.86,2.47-.8,2.18-1.9,5.22-3.24,8.92l-.07-.24,8,5.85.19.14-.13.2-3.55,5.16V191l2.25,3.16,13.48,19.08,4,5.82,1.08,1.6A3.84,3.84,0,0,1,123.55,221.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,271a2.34,2.34,0,0,1,0-.52c0-.4,0-.89,0-1.49,0-1.37.09-3.22.15-5.47.16-4.68.38-11,.61-18s.41-13.35.55-18c.06-2.25.11-4.1.15-5.47,0-.59,0-1.08,0-1.48a1.81,1.81,0,0,1,.06-.52,2.15,2.15,0,0,1,0,.52c0,.4,0,.89,0,1.49,0,1.29,0,3.16,0,5.47,0,4.61-.16,11-.4,18s-.52,13.41-.76,18c-.13,2.25-.24,4.09-.32,5.46,0,.59-.08,1.08-.11,1.48A1.71,1.71,0,0,1,122,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.3,219.8a2,2,0,0,1,.17-.55c.16-.4.35-.9.59-1.52.57-1.38,1.34-3.27,2.28-5.57l7.67-18.3,1.84-4.32,0,.27-4.18-5-.14-.17.15-.15,6.06-6.27,0,.19c-.81-2.33-1.46-4.23-1.94-5.63-.21-.62-.37-1.13-.5-1.54a3.2,3.2,0,0,1-.15-.55,2.24,2.24,0,0,1,.24.52l.6,1.5c.52,1.38,1.23,3.27,2.09,5.58l0,.1-.08.09-6,6.34v-.32l4.2,5,.11.12-.06.14-1.84,4.33c-3,7.09-5.79,13.5-7.81,18.23-1,2.28-1.83,4.14-2.43,5.51l-.68,1.48A4.79,4.79,0,0,1,124.3,219.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "97.75 180.06 103.04 185.98 99.38 192.54 121.99 219.38 102.14 191.11 105.69 185.94 97.75 180.06"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.82 218.53 137.42 193.83 137.09 189.64 124.82 218.53"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M64.47,248.59c0-.05.82.43,2.4,1.06s3.89,1.54,6.85,2.56c5.9,2,14.29,4.73,24.1,7.68l-.31.17c1.17-4.36,2.44-9.09,3.75-14l.12.29-.57-.36-17-10.79-.15-.09,0-.17c2.48-8.54,4.59-15.79,6.1-20.95.75-2.53,1.35-4.54,1.78-6,.2-.66.37-1.18.49-1.58a2.92,2.92,0,0,1,.19-.53,2,2,0,0,1-.12.55c-.1.4-.24.93-.42,1.6-.39,1.44-1,3.46-1.65,6-1.45,5.17-3.5,12.44-5.92,21l-.1-.27,17,10.75.57.36.16.1,0,.18c-1.33,4.91-2.61,9.63-3.78,14l-.07.25-.25-.08c-9.8-3-18.18-5.73-24.06-7.86-2.94-1.06-5.25-2-6.81-2.69A15.72,15.72,0,0,1,64.47,248.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2,180.61a2.67,2.67,0,0,1,.69.45,13.47,13.47,0,0,1,1.67,1.46,20.33,20.33,0,0,1,5.81,13.22,16.22,16.22,0,0,1-.05,2.22,2.37,2.37,0,0,1-.15.81c-.09,0,0-1.17-.17-3a22.49,22.49,0,0,0-5.7-13C86.05,181.41,85.14,180.69,85.2,180.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,204.72c-.14,0-.63-5.43-1.08-12.16s-.71-12.19-.57-12.2.63,5.44,1.09,12.17S151.34,204.71,151.19,204.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,172.59a3.48,3.48,0,0,1-.54.6c-.36.37-.9.91-1.61,1.59a45.34,45.34,0,0,1-6.27,5.11l-.33.22,0-.4a16.6,16.6,0,0,0-.81-5.32,13.86,13.86,0,0,0-1.29-2.66q-.41-.64-.87-1.26l-.11-.16-.06-.08,0,0h0l.32.07h0l0,0a.88.88,0,0,0-.23.24,4.44,4.44,0,0,0-.39.63,18.51,18.51,0,0,0-1.25,4.56c-.28,1.52-.52,3-.72,4.38l-.06.41-.32-.26-7.63-6.08-2.14-1.76a4.82,4.82,0,0,1-.74-.67,4.46,4.46,0,0,1,.83.55l2.23,1.66,7.74,5.93-.38.15c.19-1.4.41-2.87.69-4.4a18.25,18.25,0,0,1,1.29-4.7,3.86,3.86,0,0,1,.44-.72,1.68,1.68,0,0,1,.32-.34l.06,0h0l.33.07h0l0,0,.06.08.12.16c.32.43.62.87.89,1.31a14.27,14.27,0,0,1,1.33,2.76,17,17,0,0,1,.78,5.47l-.35-.18a53.55,53.55,0,0,0,6.35-4.92l1.69-1.5A3.8,3.8,0,0,1,131.16,172.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52,218.94c-.15,0-1.18-10.85-2.31-24.27s-1.93-24.3-1.79-24.31,1.18,10.85,2.31,24.27S123.66,218.93,123.52,218.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.92,208.25s-.88,23.53-.87,23.58L89,217.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,244l9,10h62.83l20.85-40.07a2.91,2.91,0,0,0-2.58-4.26h-61.5a2.91,2.91,0,0,0-2.69,1.8L122.5,242l-12.16-.32A1.39,1.39,0,0,0,109.28,244Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.33,242.11a4.41,4.41,0,0,1,.68.62l1.83,1.83,6.46,6.65-.35.06c1.83-4,4-8.89,6.31-14.13,3.13-7.14,5.86-13.66,7.82-18.38,1-2.31,1.75-4.2,2.33-5.58l.65-1.52a2,2,0,0,1,.26-.51,2.42,2.42,0,0,1-.16.55c-.15.41-.34.92-.56,1.55-.5,1.34-1.24,3.27-2.18,5.65-1.87,4.76-4.55,11.3-7.68,18.45-2.3,5.25-4.52,10.09-6.4,14.1l-.13.29-.22-.23-6.34-6.78c-.71-.79-1.29-1.43-1.74-1.91A4.73,4.73,0,0,1,109.33,242.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.05,234.8a3.51,3.51,0,1,1,2.06-4.86A3.76,3.76,0,0,1,163.05,234.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52,246.8l5.69-.53s10.23-3.41,11.94-3.11a2.54,2.54,0,0,1-1.31,2.81c-1.8,1.1-4.51,2.41-4.51,2.41l4.08,4.66a2.79,2.79,0,0,0,2.1,1h13.38a3.28,3.28,0,0,1-1.9,2.1c-1.41.4-11.16,3.31-11.16,3.31l-21.17-2.23Z",
    style: {
      fill: "#ffbe9d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBba);
export default __webpack_public_path__ + "static/media/BBA.b1862b8b9116a4181f0e7cb40848d1f0.svg";
export { ForwardRef as ReactComponent };